import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { 
  ChevronLeft, ChevronRight, ChevronDown, Check, Upload, MapPin, Info, 
  Clock, ShieldCheck, User as UserIcon, Users, 
  Star, Wifi, Music, Coffee, Wind, Trash2, AlertCircle, Plus, Edit2, Zap, Calendar
} from 'lucide-react';
import TimePicker12, { 
  DAY_RANGE_OPTIONS, 
  generateSlotsFromRange, 
  time12hToMinutes, 
  parseSlotRangeToMinutes,
  parseTimeTo12h,
  format12hTime,
  sortAndDeduplicateSlots,
  defaultSlotsList,
  getTurfPriceRange
} from './TimePicker12';

import { API_URL as API } from '../../config/api';
const SPORTS_LIST = ['Football', 'Cricket', 'Tennis', 'Volleyball', 'Table Tennis', 'Swimming'];

const TIME_OPTIONS = [
  '12:00 AM', '01:00 AM', '02:00 AM', '03:00 AM', '04:00 AM', '05:00 AM', '06:00 AM', '07:00 AM', '08:00 AM', '09:00 AM', '10:00 AM', '11:00 AM',
  '12:00 PM', '01:00 PM', '02:00 PM', '03:00 PM', '04:00 PM', '05:00 PM', '06:00 PM', '07:00 PM', '08:00 PM', '09:00 PM', '10:00 PM', '11:00 PM'
];

const STATE_CITY_PINCODES = {
  'Andhra Pradesh': {
    'Visakhapatnam': '530001', 'Vijayawada': '520001', 'Guntur': '522001', 'Nellore': '524001', 
    'Kurnool': '518001', 'Tirupati': '517501', 'Kakinada': '533001', 'Rajahmundry': '533101', 
    'Kadapa': '516001', 'Eluru': '534001', 'Ongole': '523001', 'Vizianagaram': '535001', 
    'Anantapur': '515001', 'Chittoor': '517001', 'Srikakulam': '532001', 'Bhimavaram': '534201', 
    'Machilipatnam': '521001', 'Narasaraopet': '522601', 'Proddatur': '516360', 'Hindupur': '515201', 
    'Adoni': '518301', 'Tenali': '522201', 'Chirala': '523155', 'Nandyal': '518501', 
    'Tadipatri': '515411', 'Madanapalle': '517325', 'Gudivada': '521301', 'Mangalagiri': '522503', 
    'Tadepalligudem': '534101', 'Puttaparthi': '515134'
  },
  'Arunachal Pradesh': {
    'Itanagar': '791111', 'Naharlagun': '791110', 'Pasighat': '791102', 'Tawang': '790104', 
    'Ziro': '791120', 'Bomdila': '790001', 'Tezu': '792001', 'Roing': '792110', 
    'Changlang': '792120', 'Namsai': '792103', 'Aalo': '791001', 'Seppa': '790102'
  },
  'Assam': {
    'Guwahati': '781001', 'Silchar': '788001', 'Dibrugarh': '786001', 'Jorhat': '785001', 
    'Nagaon': '782001', 'Tinsukia': '786125', 'Tezpur': '784001', 'Bongaigaon': '783380', 
    'Dhubri': '783301', 'Diphu': '782460', 'Karimganj': '788710', 'Goalpara': '783101', 
    'Hailakandi': '788151', 'Sivasagar': '785640', 'Golaghat': '785621', 'Lakhimpur': '787001', 
    'Barpeta': '781301', 'Nalbari': '781335', 'Kokrajhar': '783370', 'Hojai': '782435', 
    'Dhemaji': '787057', 'Morigaon': '782105'
  },
  'Bihar': {
    'Patna': '800001', 'Gaya': '823001', 'Bhagalpur': '812001', 'Muzaffarpur': '842001', 
    'Purnia': '854301', 'Darbhanga': '846004', 'Arrah': '802301', 'Bihar Sharif': '803101', 
    'Begusarai': '851101', 'Katihar': '854105', 'Munger': '811201', 'Chhapra': '841301', 
    'Dehri': '821307', 'Bettiah': '845438', 'Motihari': '845401', 'Hajipur': '844101', 
    'Jehanabad': '804408', 'Nawada': '805110', 'Siwan': '841226', 'Sasaram': '821115', 
    'Aurangabad': '824101', 'Buxar': '802101', 'Kishanganj': '855107', 'Sitamarhi': '843302', 
    'Supaul': '852131', 'Madhubani': '847211', 'Samastipur': '848101'
  },
  'Chhattisgarh': {
    'Raipur': '492001', 'Bhilai': '490001', 'Bilaspur': '495001', 'Korba': '495677', 
    'Raigarh': '496001', 'Durg': '491001', 'Rajnandgaon': '491441', 'Jagdalpur': '494001', 
    'Ambikapur': '497001', 'Dhamtari': '493773', 'Chirmiri': '497449', 'Kanker': '494334', 
    'Mahasamund': '493445', 'Kawardha': '491995', 'Balod': '491226', 'Mungeli': '495334', 
    'Kondagaon': '494226', 'Narayanpur': '494661'
  },
  'Goa': {
    'Panaji': '403001', 'Margao': '403601', 'Vasco da Gama': '403802', 'Mapusa': '403507', 
    'Ponda': '403401', 'Bicholim': '403504', 'Curchorem': '403706', 'Sanquelim': '403505', 
    'Cuncolim': '403703', 'Valpoi': '403506'
  },
  'Gujarat': {
    'Ahmedabad': '380001', 'Surat': '395003', 'Vadodara': '390001', 'Rajkot': '360001', 
    'Bhavnagar': '364001', 'Jamnagar': '361001', 'Gandhinagar': '382010', 'Junagadh': '362001', 
    'Anand': '388001', 'Nadiad': '387001', 'Morbi': '363641', 'Surendranagar': '363001', 
    'Mehsana': '384001', 'Bharuch': '392001', 'Navsari': '396445', 'Valsad': '396001', 
    'Amreli': '365601', 'Porbandar': '360575', 'Palanpur': '385001', 'Godhra': '389001', 
    'Botad': '364710', 'Patan': '384265', 'Dahod': '389151', 'Veraval': '362265', 
    'Gandhidham': '370201', 'Deesa': '385535', 'Himatnagar': '383001', 'Modasa': '383315', 
    'Kalol': '382721'
  },
  'Haryana': {
    'Gurugram': '122001', 'Faridabad': '121001', 'Panipat': '132103', 'Ambala': '133001', 
    'Hisar': '125001', 'Rohtak': '124001', 'Karnal': '132001', 'Sonipat': '131001', 
    'Yamunanagar': '135001', 'Panchkula': '134109', 'Bhiwani': '127021', 'Sirsa': '125055', 
    'Bahadurgarh': '124507', 'Jind': '126102', 'Thanesar': '136118', 'Kaithal': '136027', 
    'Palwal': '121102', 'Rewari': '123401', 'Narnaul': '123001', 'Fatehabad': '125050', 
    'Mahendragarh': '123029'
  },
  'Himachal Pradesh': {
    'Shimla': '171001', 'Manali': '175131', 'Dharamshala': '176215', 'Solan': '173212', 
    'Mandi': '175001', 'Palampur': '176061', 'Baddi': '173205', 'Nahan': '173001', 
    'Una': '174303', 'Hamirpur': '177001', 'Bilaspur': '174001', 'Chamba': '176310', 
    'Kullu': '175101', 'Kangra': '176001', 'Parwanoo': '173220', 'Sundarnagar': '175002', 
    'Rampur': '172001'
  },
  'Jharkhand': {
    'Ranchi': '834001', 'Jamshedpur': '831001', 'Dhanbad': '826001', 'Bokaro': '827001', 
    'Hazaribagh': '825301', 'Deoghar': '814112', 'Phusro': '829144', 'Adityapur': '831013', 
    'Giridih': '815301', 'Ramgarh': '829122', 'Medininagar': '822101', 'Chirkunda': '828202', 
    'Chaibasa': '833201', 'Dumka': '814101', 'Gumla': '835207', 'Lohardaga': '835302', 
    'Pakur': '816107', 'Jamtara': '815351'
  },
  'Karnataka': {
    'Bengaluru': '560001', 'Mysuru': '570001', 'Hubballi': '580020', 'Mangaluru': '575001', 
    'Belagavi': '590001', 'Davangere': '577001', 'Ballari': '583101', 'Vijayapura': '586101', 
    'Shivamogga': '577201', 'Tumakuru': '572101', 'Udupi': '576101', 'Bidar': '585401', 
    'Hassan': '573201', 'Chitradurga': '577501', 'Raichur': '584101', 'Dharwad': '580001', 
    'Bagalkot': '587101', 'Kalaburagi': '585101', 'Mandya': '571401', 'Chikkamagaluru': '577101', 
    'Kolar': '563101', 'Ramanagara': '562159', 'Gadag': '582101', 'Koppal': '583231', 
    'Chamarajanagar': '571313', 'Haveri': '581110', 'Yadgir': '585201', 'Chikkaballapur': '562101', 
    'Kodagu': '571201', 'Bangalore North': '560003', 'Bangalore South': '560041', 
    'Anekal': '562106', 'Whitefield': '560066', 'Electronic City': '560100', 'Hebbal': '560024', 
    'Yeshwanthpur': '560022', 'Rajajinagar': '560010'
  },
  'Kerala': {
    'Kochi': '682001', 'Thiruvananthapuram': '695001', 'Kozhikode': '673001', 'Thrissur': '680001', 
    'Kannur': '670001', 'Kollam': '691001', 'Palakkad': '678001', 'Alappuzha': '688001', 
    'Kottayam': '686001', 'Malappuram': '676505', 'Pathanamthitta': '689645', 'Idukki': '685602', 
    'Wayanad': '670645', 'Kasaragod': '671121', 'Ernakulam': '682011', 'Aluva': '683101', 
    'Perinthalmanna': '679322', 'Chalakudy': '680307', 'Punalur': '691305', 'Attingal': '695101', 
    'Vatakara': '673101', 'Manjeri': '676121', 'Tirur': '676101', 'Guruvayur': '680101', 
    'Irinjalakuda': '680121'
  },
  'Madhya Pradesh': {
    'Bhopal': '462001', 'Indore': '452001', 'Jabalpur': '482001', 'Gwalior': '474001', 
    'Ujjain': '456001', 'Sagar': '470001', 'Dewas': '455001', 'Satna': '485001', 
    'Ratlam': '457001', 'Rewa': '486001', 'Murwara': '483501', 'Singrauli': '486889', 
    'Burhanpur': '450331', 'Khandwa': '450001', 'Bhind': '477001', 'Chhindwara': '480001', 
    'Guna': '473001', 'Shivpuri': '473551', 'Vidisha': '464001', 'Chhatarpur': '471001', 
    'Damoh': '470661', 'Mandsaur': '458001', 'Khargone': '451001', 'Neemuch': '458441', 
    'Pithampur': '454775', 'Hoshangabad': '461001', 'Itarsi': '461111', 'Sehore': '466001', 
    'Betul': '460001', 'Seoni': '480661', 'Morena': '476001', 'Katni': '483501'
  },
  'Maharashtra': {
    'Mumbai': '400001', 'Pune': '411001', 'Nagpur': '440001', 'Thane': '400601', 
    'Nashik': '422001', 'Aurangabad': '431001', 'Solapur': '413001', 'Kolhapur': '416001', 
    'Navi Mumbai': '400703', 'Amravati': '444601', 'Akola': '444001', 'Latur': '413512', 
    'Chandrapur': '442401', 'Jalgaon': '425001', 'Bhiwandi': '421302', 'Sangli': '416416', 
    'Malegaon': '423203', 'Jalna': '431203', 'Dhule': '424001', 'Ahmednagar': '414001', 
    'Ichalkaranji': '416115', 'Parbhani': '431401', 'Panvel': '410206', 'Nanded': '431601', 
    'Kalyan': '421301', 'Vasai-Virar': '401201', 'Mira-Bhayandar': '401107', 'Ulhasnagar': '421001', 
    'Bhusawal': '425201', 'Gondia': '441601', 'Satara': '415001', 'Yavatmal': '445001', 
    'Ratnagiri': '415612', 'Wardha': '442001', 'Washim': '444505', 'Hingoli': '431513', 
    'Beed': '431122', 'Osmanabad': '413501', 'Sindhudurg': '416812', 'Raigad': '402107'
  },
  'Manipur': {
    'Imphal': '795001', 'Thoubal': '795138', 'Bishnupur': '795126', 'Churachandpur': '795128', 
    'Kakching': '795103', 'Moreh': '795131', 'Senapati': '795106', 'Ukhrul': '795142', 
    'Tamenglong': '795141'
  },
  'Meghalaya': {
    'Shillong': '793001', 'Tura': '794001', 'Jowai': '793150', 'Nongstoin': '793119', 
    'Baghmara': '794102', 'Resubelpara': '794108', 'Williamnagar': '794111', 
    'Nongpoh': '793102', 'Mawkyrwat': '793114'
  },
  'Mizoram': {
    'Aizawl': '796001', 'Lunglei': '796701', 'Champhai': '796321', 'Kolasib': '796081', 
    'Serchhip': '796181', 'Saiha': '796901', 'Mamit': '796431', 'Lawngtlai': '796891'
  },
  'Nagaland': {
    'Kohima': '797001', 'Dimapur': '797112', 'Mokokchung': '798601', 'Tuensang': '798612', 
    'Wokha': '797111', 'Zunheboto': '798620', 'Mon': '798621', 'Phek': '797108', 
    'Kiphire': '798611', 'Longleng': '798625'
  },
  'Odisha': {
    'Bhubaneswar': '751001', 'Cuttack': '753001', 'Rourkela': '769001', 'Berhampur': '760001', 
    'Sambalpur': '768001', 'Puri': '752001', 'Balasore': '756001', 'Baripada': '757001', 
    'Bhadrak': '756100', 'Jharsuguda': '768201', 'Angul': '759122', 'Dhenkanal': '759001', 
    'Koraput': '764020', 'Phulbani': '762001', 'Rayagada': '765001', 'Sundargarh': '770001', 
    'Kendujhar': '758001', 'Jajpur': '755001', 'Paradip': '754142', 'Kendrapara': '754211', 
    'Jagatsinghpur': '754103', 'Nabarangpur': '764059', 'Malkangiri': '764045', 
    'Bolangir': '767001', 'Bargarh': '768028'
  },
  'Punjab': {
    'Ludhiana': '141001', 'Amritsar': '143001', 'Jalandhar': '144001', 'Patiala': '147001', 
    'Bathinda': '151001', 'Mohali': '160055', 'Hoshiarpur': '146001', 'Gurdaspur': '143521', 
    'Pathankot': '145001', 'Moga': '142001', 'Barnala': '148101', 'Faridkot': '151203', 
    'Firozpur': '152002', 'Kapurthala': '144601', 'Sangrur': '148001', 'Rupnagar': '140001', 
    'Muktsar': '152026', 'Fazilka': '152123', 'Malerkotla': '148023', 'Tarn Taran': '143401', 
    'Zirakpur': '140603', 'Kharar': '140301'
  },
  'Rajasthan': {
    'Jaipur': '302001', 'Jodhpur': '342001', 'Kota': '324001', 'Bikaner': '334001', 
    'Ajmer': '305001', 'Udaipur': '313001', 'Alwar': '301001', 'Bhilwara': '311001', 
    'Sikar': '332001', 'Bharatpur': '321001', 'Sri Ganganagar': '335001', 'Pali': '306401', 
    'Barmer': '344001', 'Tonk': '304001', 'Jhunjhunu': '333001', 'Chittorgarh': '312001', 
    'Nagaur': '341001', 'Hanumangarh': '335513', 'Dungarpur': '314001', 'Dausa': '303303', 
    'Jalore': '343001', 'Baran': '325205', 'Banswara': '327001', 'Karauli': '322241', 
    'Sawai Madhopur': '322001', 'Dholpur': '328001', 'Bundi': '323001', 'Jaisalmer': '345001', 
    'Sirohi': '307001', 'Rajsamand': '313324', 'Churu': '331001', 'Pratapgarh': '312605', 
    'Jhalawar': '326001'
  },
  'Sikkim': {
    'Gangtok': '737101', 'Namchi': '737126', 'Gyalshing': '737111', 'Mangan': '737116', 
    'Ravangla': '737139', 'Jorethang': '737121'
  },
  'Tamil Nadu': {
    'Chennai': '600001', 'Coimbatore': '641001', 'Madurai': '625001', 'Salem': '636001', 
    'Tiruchirappalli': '620001', 'Tirunelveli': '627001', 'Vellore': '632001', 'Erode': '638001', 
    'Tiruppur': '641601', 'Thoothukudi': '628001', 'Dindigul': '624001', 'Thanjavur': '613001', 
    'Ranipet': '632401', 'Kanchipuram': '631501', 'Nagapattinam': '611001', 'Namakkal': '637001', 
    'Villupuram': '605602', 'Cuddalore': '607001', 'Karur': '639001', 'Nagercoil': '629001', 
    'Ooty': '643001', 'Kumbakonam': '612001', 'Virudhunagar': '626001', 'Sivakasi': '626123', 
    'Hosur': '635109', 'Krishnagiri': '635001', 'Dharmapuri': '636701', 'Ramanathapuram': '623501', 
    'Pudukkottai': '622001', 'Sivaganga': '630561', 'Ariyalur': '621704', 'Perambalur': '621212', 
    'Theni': '625531', 'Tiruvannamalai': '606601', 'Kallakurichi': '606202', 
    'Chengalpattu': '603001', 'Mayiladuthurai': '609001'
  },
  'Telangana': {
    'Hyderabad': '500001', 'Warangal': '506001', 'Nizamabad': '503001', 'Karimnagar': '505001', 
    'Khammam': '507001', 'Ramagundam': '505208', 'Secunderabad': '500003', 'Mancherial': '504208', 
    'Nalgonda': '508001', 'Adilabad': '504001', 'Suryapet': '508213', 'Miryalaguda': '508207', 
    'Jagtial': '505327', 'Siddipet': '502103', 'Sangareddy': '502001', 'Mahabubnagar': '509001', 
    'Wanaparthy': '509103', 'Nagarkurnool': '509209', 'Nirmal': '504106', 'Kamareddy': '503111', 
    'Medak': '502110', 'Narayanpet': '509210', 'Vikarabad': '501101', 'Jangaon': '506167', 
    'Peddapalli': '505172', 'Bhadradri Kothagudem': '507101', 'Mulugu': '506352', 
    'Jayashankar': '506349', 'Kukatpally': '500072', 'Lb Nagar': '500074', 'Uppal': '500039', 
    'Medchal': '501401', 'Shamshabad': '501218'
  },
  'Tripura': {
    'Agartala': '799001', 'Udaipur': '799120', 'Dharmanagar': '799250', 'Sabroom': '799145', 
    'Belonia': '799155', 'Kailasahar': '799277', 'Khowai': '799201', 'Ambassa': '799289'
  },
  'Uttar Pradesh': {
    'Lucknow': '226001', 'Kanpur': '208001', 'Agra': '282001', 'Varanasi': '221001', 
    'Meerut': '250001', 'Prayagraj': '211001', 'Bareilly': '243001', 'Aligarh': '202001', 
    'Moradabad': '244001', 'Gorakhpur': '273001', 'Noida': '201301', 'Ghaziabad': '201001', 
    'Firozabad': '283203', 'Mathura': '281001', 'Muzaffarnagar': '251001', 'Saharanpur': '247001', 
    'Rampur': '244901', 'Shahjahanpur': '242001', 'Farrukhabad': '209625', 'Hapur': '245101', 
    'Etawah': '206001', 'Mirzapur': '231001', 'Bulandshahr': '203001', 'Sambhal': '244302', 
    'Amroha': '244221', 'Hardoi': '241001', 'Azamgarh': '276001', 'Sitapur': '261001', 
    'Lakhimpur': '262701', 'Hathras': '204101', 'Unnao': '209801', 'Jhansi': '284001', 
    'Orai': '285001', 'Banda': '210001', 'Jaunpur': '222001', 'Ballia': '277001', 
    'Deoria': '274001', 'Basti': '272001', 'Faizabad': '224001', 'Sultanpur': '228001', 
    'Raebareli': '229001', 'Fatehpur': '212601', 'Mainpuri': '205001', 'Etah': '207001', 
    'Budaun': '243601', 'Greater Noida': '201308', 'Vrindavan': '281121'
  },
  'Uttarakhand': {
    'Dehradun': '248001', 'Haridwar': '249401', 'Rishikesh': '249201', 'Roorkee': '247667', 
    'Haldwani': '263139', 'Nainital': '263001', 'Rudrapur': '263153', 'Kashipur': '244713', 
    'Kotdwar': '246149', 'Ramnagar': '244715', 'Almora': '263601', 'Pithoragarh': '262501', 
    'Bageshwar': '263642', 'Pauri': '246001', 'Chamoli': '246424', 'Uttarkashi': '249193', 
    'Mussoorie': '248179'
  },
  'West Bengal': {
    'Kolkata': '700001', 'Howrah': '711101', 'Durgapur': '713201', 'Asansol': '713301', 
    'Siliguri': '734001', 'Bardhaman': '713101', 'Malda': '732101', 'Baharampur': '742101', 
    'Habra': '743263', 'Kharagpur': '721301', 'Shantipur': '741404', 'Dankuni': '712311', 
    'Dhulian': '742202', 'Ranaghat': '741201', 'Haldia': '721602', 'Raiganj': '733134', 
    'Krishnanagar': '741101', 'Nabadwip': '741302', 'Medinipur': '721101', 'Jalpaiguri': '735101', 
    'Balurghat': '733101', 'Bankura': '722101', 'Purulia': '723101', 'Cooch Behar': '736101', 
    'Alipurduar': '736121', 'Kalimpong': '734301', 'Darjeeling': '734101', 'Bishnupur': '722122', 
    'Tamluk': '721636', 'Salt Lake': '700064', 'New Town': '700156', 'Barasat': '700124', 
    'Baranagar': '700036', 'Dum Dum': '700028'
  },
  'Delhi': {
    'New Delhi': '110001', 'Central Delhi': '110001', 'North Delhi': '110007', 
    'South Delhi': '110017', 'East Delhi': '110092', 'West Delhi': '110018', 
    'North East Delhi': '110094', 'North West Delhi': '110052', 'South East Delhi': '110019', 
    'South West Delhi': '110021', 'Shahdara': '110032', 'Dwarka': '110075', 'Rohini': '110085', 
    'Janakpuri': '110058', 'Lajpat Nagar': '110024', 'Karol Bagh': '110005', 
    'Connaught Place': '110001', 'Saket': '110017', 'Nehru Place': '110019', 
    'Preet Vihar': '110092', 'Mayur Vihar': '110091', 'Pitampura': '110034', 
    'Vikaspuri': '110018', 'Uttam Nagar': '110059'
  },
  'Chandigarh': {
    'Chandigarh': '160017', 'Manimajra': '160101', 'Panchkula': '134109', 'Mohali': '160055'
  },
  'Jammu & Kashmir': {
    'Srinagar': '190001', 'Jammu': '180001', 'Anantnag': '192101', 'Baramulla': '193101', 
    'Sopore': '193201', 'Kathua': '184101', 'Udhampur': '182101', 'Rajouri': '185131', 
    'Poonch': '185101', 'Pulwama': '192301', 'Budgam': '191111', 'Kulgam': '192315', 
    'Kupwara': '193222', 'Ganderbal': '191201', 'Bandipora': '193502', 'Ramban': '182148', 
    'Reasi': '182311', 'Kishtwar': '182204'
  },
  'Ladakh': {
    'Leh': '194101', 'Kargil': '194103', 'Diskit': '194401', 'Padum': '194302'
  },
  'Puducherry': {
    'Puducherry': '605001', 'Karaikal': '609602', 'Mahe': '673310', 'Yanam': '533464', 
    'Ozhikaraikal': '609602'
  },
  'Andaman & Nicobar': {
    'Port Blair': '744101', 'Diglipur': '744202', 'Car Nicobar': '744301', 'Havelock Island': '744211'
  },
  'Lakshadweep': {
    'Kavaratti': '682555', 'Agatti': '682553', 'Amini': '682552', 'Androth': '682551', 'Minicoy': '682559'
  },
  'Dadra & Nagar Haveli and Daman & Diu': {
    'Silvassa': '396230', 'Daman': '396210', 'Diu': '362520', 'Dadra': '396230'
  }
};

const getCityPincode = (stateName, city) => {
  if (!city) return '';
  const cleanState = (stateName || '').trim();
  const cleanCity = city.trim();
  
  if (cleanState && STATE_CITY_PINCODES[cleanState]) {
    const cityMap = STATE_CITY_PINCODES[cleanState];
    const match = Object.keys(cityMap).find(k => k.toLowerCase() === cleanCity.toLowerCase());
    if (match) return cityMap[match];
  }
  
  for (const s of Object.keys(STATE_CITY_PINCODES)) {
    const cityMap = STATE_CITY_PINCODES[s];
    const match = Object.keys(cityMap).find(k => k.toLowerCase() === cleanCity.toLowerCase());
    if (match) return cityMap[match];
  }
  
  const zonePrefixes = {
    'Delhi': '110001', 'Haryana': '122001', 'Punjab': '141001', 'Himachal Pradesh': '171001', 
    'Jammu & Kashmir': '190001', 'Ladakh': '194101', 'Chandigarh': '160017',
    'Uttar Pradesh': '226001', 'Uttarakhand': '248001',
    'Rajasthan': '302001', 'Gujarat': '380001', 'Dadra & Nagar Haveli and Daman & Diu': '396210',
    'Maharashtra': '400001', 'Goa': '403001', 'Chhattisgarh': '492001', 'Madhya Pradesh': '462001',
    'Andhra Pradesh': '530001', 'Telangana': '500001', 'Karnataka': '560001',
    'Tamil Nadu': '600001', 'Kerala': '682001', 'Puducherry': '605001', 'Lakshadweep': '682555',
    'West Bengal': '700001', 'Odisha': '751001', 'Sikkim': '737101', 'Andaman & Nicobar': '744101',
    'Bihar': '800001', 'Jharkhand': '834001',
    'Assam': '781001', 'Arunachal Pradesh': '791111', 'Manipur': '795001', 'Meghalaya': '793001', 
    'Mizoram': '796001', 'Nagaland': '797001', 'Tripura': '799001'
  };
  
  return zonePrefixes[cleanState] || '560001';
};

const LOCATION_DATA = {
  'Andhra Pradesh': [
    'Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool', 'Tirupati',
    'Kakinada', 'Rajahmundry', 'Kadapa', 'Eluru', 'Ongole', 'Vizianagaram',
    'Anantapur', 'Chittoor', 'Srikakulam', 'Bhimavaram', 'Machilipatnam',
    'Narasaraopet', 'Proddatur', 'Hindupur', 'Adoni', 'Tenali', 'Chirala',
    'Nandyal', 'Tadipatri', 'Madanapalle', 'Gudivada', 'Mangalagiri',
    'Tadepalligudem', 'Puttaparthi',
  ],
  'Arunachal Pradesh': [
    'Itanagar', 'Naharlagun', 'Pasighat', 'Tawang', 'Ziro', 'Bomdila',
    'Tezu', 'Roing', 'Changlang', 'Namsai', 'Aalo', 'Seppa',
  ],
  'Assam': [
    'Guwahati', 'Silchar', 'Dibrugarh', 'Jorhat', 'Nagaon', 'Tinsukia',
    'Tezpur', 'Bongaigaon', 'Dhubri', 'Diphu', 'Karimganj', 'Goalpara',
    'Hailakandi', 'Sivasagar', 'Golaghat', 'Lakhimpur', 'Barpeta',
    'Nalbari', 'Kokrajhar', 'Hojai', 'Dhemaji', 'Morigaon',
  ],
  'Bihar': [
    'Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Purnia', 'Darbhanga',
    'Arrah', 'Bihar Sharif', 'Begusarai', 'Katihar', 'Munger', 'Chhapra',
    'Dehri', 'Bettiah', 'Motihari', 'Hajipur', 'Jehanabad', 'Nawada',
    'Siwan', 'Sasaram', 'Aurangabad', 'Buxar', 'Kishanganj', 'Sitamarhi',
    'Supaul', 'Madhubani', 'Samastipur',
  ],
  'Chhattisgarh': [
    'Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Raigarh', 'Durg', 'Rajnandgaon',
    'Jagdalpur', 'Ambikapur', 'Dhamtari', 'Chirmiri', 'Kanker', 'Mahasamund',
    'Kawardha', 'Balod', 'Mungeli', 'Kondagaon', 'Narayanpur',
  ],
  'Goa': [
    'Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda', 'Bicholim',
    'Curchorem', 'Sanquelim', 'Cuncolim', 'Valpoi',
  ],
  'Gujarat': [
    'Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar',
    'Gandhinagar', 'Junagadh', 'Anand', 'Nadiad', 'Morbi', 'Surendranagar',
    'Mehsana', 'Bharuch', 'Navsari', 'Valsad', 'Amreli', 'Porbandar',
    'Palanpur', 'Godhra', 'Botad', 'Patan', 'Dahod', 'Veraval',
    'Gandhidham', 'Deesa', 'Himatnagar', 'Modasa', 'Kalol',
  ],
  'Haryana': [
    'Gurugram', 'Faridabad', 'Panipat', 'Ambala', 'Hisar', 'Rohtak',
    'Karnal', 'Sonipat', 'Yamunanagar', 'Panchkula', 'Bhiwani', 'Sirsa',
    'Bahadurgarh', 'Jind', 'Thanesar', 'Kaithal', 'Palwal', 'Rewari',
    'Narnaul', 'Fatehabad', 'Mahendragarh',
  ],
  'Himachal Pradesh': [
    'Shimla', 'Manali', 'Dharamshala', 'Solan', 'Mandi', 'Palampur',
    'Baddi', 'Nahan', 'Una', 'Hamirpur', 'Bilaspur', 'Chamba',
    'Kullu', 'Kangra', 'Parwanoo', 'Sundarnagar', 'Rampur',
  ],
  'Jharkhand': [
    'Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Hazaribagh', 'Deoghar',
    'Phusro', 'Adityapur', 'Giridih', 'Ramgarh', 'Medininagar', 'Chirkunda',
    'Chaibasa', 'Dumka', 'Gumla', 'Lohardaga', 'Pakur', 'Jamtara',
  ],
  'Karnataka': [
    'Bengaluru', 'Mysuru', 'Hubballi', 'Mangaluru', 'Belagavi', 'Davangere',
    'Ballari', 'Vijayapura', 'Shivamogga', 'Tumakuru', 'Udupi', 'Bidar',
    'Hassan', 'Chitradurga', 'Raichur', 'Dharwad', 'Bagalkot', 'Kalaburagi',
    'Mandya', 'Chikkamagaluru', 'Kolar', 'Ramanagara', 'Gadag', 'Koppal',
    'Chamarajanagar', 'Haveri', 'Yadgir', 'Chikkaballapur', 'Kodagu',
    'Bangalore North', 'Bangalore South', 'Anekal', 'Whitefield',
    'Electronic City', 'Hebbal', 'Yeshwanthpur', 'Rajajinagar',
  ],
  'Kerala': [
    'Kochi', 'Thiruvananthapuram', 'Kozhikode', 'Thrissur', 'Kannur',
    'Kollam', 'Palakkad', 'Alappuzha', 'Kottayam', 'Malappuram',
    'Pathanamthitta', 'Idukki', 'Wayanad', 'Kasaragod', 'Ernakulam',
    'Aluva', 'Perinthalmanna', 'Chalakudy', 'Punalur', 'Attingal',
    'Vatakara', 'Manjeri', 'Tirur', 'Guruvayur', 'Irinjalakuda',
  ],
  'Madhya Pradesh': [
    'Bhopal', 'Indore', 'Jabalpur', 'Gwalior', 'Ujjain', 'Sagar',
    'Dewas', 'Satna', 'Ratlam', 'Rewa', 'Murwara', 'Singrauli',
    'Burhanpur', 'Khandwa', 'Bhind', 'Chhindwara', 'Guna', 'Shivpuri',
    'Vidisha', 'Chhatarpur', 'Damoh', 'Mandsaur', 'Khargone',
    'Neemuch', 'Pithampur', 'Hoshangabad', 'Itarsi', 'Sehore', 'Betul',
    'Seoni', 'Morena', 'Katni',
  ],
  'Maharashtra': [
    'Mumbai', 'Pune', 'Nagpur', 'Thane', 'Nashik', 'Aurangabad',
    'Solapur', 'Kolhapur', 'Navi Mumbai', 'Amravati', 'Akola', 'Latur',
    'Chandrapur', 'Jalgaon', 'Bhiwandi', 'Sangli', 'Malegaon', 'Jalna',
    'Dhule', 'Ahmednagar', 'Ichalkaranji', 'Parbhani', 'Panvel', 'Nanded',
    'Kalyan', 'Vasai-Virar', 'Mira-Bhayandar', 'Ulhasnagar', 'Bhusawal',
    'Gondia', 'Satara', 'Yavatmal', 'Ratnagiri', 'Wardha', 'Washim',
    'Hingoli', 'Beed', 'Osmanabad', 'Sindhudurg', 'Raigad',
  ],
  'Manipur': [
    'Imphal', 'Thoubal', 'Bishnupur', 'Churachandpur', 'Kakching',
    'Moreh', 'Senapati', 'Ukhrul', 'Tamenglong',
  ],
  'Meghalaya': [
    'Shillong', 'Tura', 'Jowai', 'Nongstoin', 'Baghmara', 'Resubelpara',
    'Williamnagar', 'Nongpoh', 'Mawkyrwat',
  ],
  'Mizoram': [
    'Aizawl', 'Lunglei', 'Champhai', 'Kolasib', 'Serchhip',
    'Saiha', 'Mamit', 'Lawngtlai',
  ],
  'Nagaland': [
    'Kohima', 'Dimapur', 'Mokokchung', 'Tuensang', 'Wokha',
    'Zunheboto', 'Mon', 'Phek', 'Kiphire', 'Longleng',
  ],
  'Odisha': [
    'Bhubaneswar', 'Cuttack', 'Rourkela', 'Berhampur', 'Sambalpur',
    'Puri', 'Balasore', 'Baripada', 'Bhadrak', 'Jharsuguda',
    'Angul', 'Dhenkanal', 'Koraput', 'Phulbani', 'Rayagada',
    'Sundargarh', 'Kendujhar', 'Jajpur', 'Paradip', 'Kendrapara',
    'Jagatsinghpur', 'Nabarangpur', 'Malkangiri', 'Bolangir', 'Bargarh',
  ],
  'Punjab': [
    'Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Mohali',
    'Hoshiarpur', 'Gurdaspur', 'Pathankot', 'Moga', 'Barnala', 'Faridkot',
    'Firozpur', 'Kapurthala', 'Sangrur', 'Rupnagar', 'Muktsar', 'Fazilka',
    'Malerkotla', 'Tarn Taran', 'Zirakpur', 'Kharar',
  ],
  'Rajasthan': [
    'Jaipur', 'Jodhpur', 'Kota', 'Bikaner', 'Ajmer', 'Udaipur',
    'Alwar', 'Bhilwara', 'Sikar', 'Bharatpur', 'Sri Ganganagar',
    'Pali', 'Barmer', 'Tonk', 'Jhunjhunu', 'Chittorgarh', 'Nagaur',
    'Hanumangarh', 'Dungarpur', 'Dausa', 'Jalore', 'Baran',
    'Banswara', 'Karauli', 'Sawai Madhopur', 'Dholpur', 'Bundi',
    'Jaisalmer', 'Sirohi', 'Rajsamand', 'Churu', 'Pratapgarh', 'Jhalawar',
  ],
  'Sikkim': [
    'Gangtok', 'Namchi', 'Gyalshing', 'Mangan', 'Ravangla', 'Jorethang',
  ],
  'Tamil Nadu': [
    'Chennai', 'Coimbatore', 'Madurai', 'Salem', 'Tiruchirappalli', 'Tirunelveli',
    'Vellore', 'Erode', 'Tiruppur', 'Thoothukudi', 'Dindigul', 'Thanjavur',
    'Ranipet', 'Kanchipuram', 'Nagapattinam', 'Namakkal', 'Villupuram',
    'Cuddalore', 'Karur', 'Nagercoil', 'Ooty', 'Kumbakonam', 'Virudhunagar',
    'Sivakasi', 'Hosur', 'Krishnagiri', 'Dharmapuri', 'Ramanathapuram',
    'Pudukkottai', 'Sivaganga', 'Ariyalur', 'Perambalur', 'Theni',
    'Tiruvannamalai', 'Kallakurichi', 'Chengalpattu', 'Mayiladuthurai',
  ],
  'Telangana': [
    'Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Khammam',
    'Ramagundam', 'Secunderabad', 'Mancherial', 'Nalgonda', 'Adilabad',
    'Suryapet', 'Miryalaguda', 'Jagtial', 'Siddipet', 'Sangareddy',
    'Mahabubnagar', 'Wanaparthy', 'Nagarkurnool', 'Nirmal', 'Kamareddy',
    'Medak', 'Narayanpet', 'Vikarabad', 'Jangaon', 'Peddapalli',
    'Bhadradri Kothagudem', 'Mulugu', 'Jayashankar',
    'Kukatpally', 'Lb Nagar', 'Uppal', 'Medchal', 'Shamshabad',
  ],
  'Tripura': [
    'Agartala', 'Udaipur', 'Dharmanagar', 'Sabroom', 'Belonia',
    'Kailasahar', 'Khowai', 'Ambassa',
  ],
  'Uttar Pradesh': [
    'Lucknow', 'Kanpur', 'Agra', 'Varanasi', 'Meerut', 'Prayagraj',
    'Bareilly', 'Aligarh', 'Moradabad', 'Gorakhpur', 'Noida', 'Ghaziabad',
    'Firozabad', 'Mathura', 'Muzaffarnagar', 'Saharanpur', 'Rampur',
    'Shahjahanpur', 'Farrukhabad', 'Hapur', 'Etawah', 'Mirzapur',
    'Bulandshahr', 'Sambhal', 'Amroha', 'Hardoi', 'Azamgarh',
    'Sitapur', 'Lakhimpur', 'Hathras', 'Unnao', 'Jhansi',
    'Orai', 'Banda', 'Jaunpur', 'Ballia', 'Deoria',
    'Basti', 'Faizabad', 'Sultanpur', 'Raebareli', 'Fatehpur',
    'Mainpuri', 'Etah', 'Budaun', 'Greater Noida', 'Vrindavan',
  ],
  'Uttarakhand': [
    'Dehradun', 'Haridwar', 'Rishikesh', 'Roorkee', 'Haldwani', 'Nainital',
    'Rudrapur', 'Kashipur', 'Kotdwar', 'Ramnagar', 'Almora', 'Pithoragarh',
    'Bageshwar', 'Pauri', 'Chamoli', 'Uttarkashi', 'Mussoorie',
  ],
  'West Bengal': [
    'Kolkata', 'Howrah', 'Durgapur', 'Asansol', 'Siliguri', 'Bardhaman',
    'Malda', 'Baharampur', 'Habra', 'Kharagpur', 'Shantipur', 'Dankuni',
    'Dhulian', 'Ranaghat', 'Haldia', 'Raiganj', 'Krishnanagar', 'Nabadwip',
    'Medinipur', 'Jalpaiguri', 'Balurghat', 'Bankura', 'Purulia', 'Cooch Behar',
    'Alipurduar', 'Kalimpong', 'Darjeeling', 'Bishnupur', 'Tamluk',
    'Salt Lake', 'New Town', 'Barasat', 'Baranagar', 'Dum Dum',
  ],
  'Delhi': [
    'New Delhi', 'Central Delhi', 'North Delhi', 'South Delhi', 'East Delhi',
    'West Delhi', 'North East Delhi', 'North West Delhi', 'South East Delhi',
    'South West Delhi', 'Shahdara', 'Dwarka', 'Rohini', 'Janakpuri',
    'Lajpat Nagar', 'Karol Bagh', 'Connaught Place', 'Saket', 'Nehru Place',
    'Preet Vihar', 'Mayur Vihar', 'Pitampura', 'Vikaspuri', 'Uttam Nagar',
  ],
  'Chandigarh': ['Chandigarh', 'Manimajra', 'Panchkula', 'Mohali'],
  'Jammu & Kashmir': [
    'Srinagar', 'Jammu', 'Anantnag', 'Baramulla', 'Sopore', 'Kathua',
    'Udhampur', 'Rajouri', 'Poonch', 'Pulwama', 'Budgam', 'Kulgam',
    'Kupwara', 'Ganderbal', 'Bandipora', 'Ramban', 'Reasi', 'Kishtwar',
  ],
  'Ladakh': ['Leh', 'Kargil', 'Diskit', 'Padum'],
  'Puducherry': ['Puducherry', 'Karaikal', 'Mahe', 'Yanam', 'Ozhikaraikal'],
  'Andaman & Nicobar': ['Port Blair', 'Diglipur', 'Car Nicobar', 'Havelock Island'],
  'Lakshadweep': ['Kavaratti', 'Agatti', 'Amini', 'Androth', 'Minicoy'],
  'Dadra & Nagar Haveli and Daman & Diu': [
    'Silvassa', 'Daman', 'Diu', 'Dadra',
  ],
};

export default function AddVenueForm({ onCancel, onComplete }) {
  const { token } = useAuth();
  const { colors, theme } = useTheme();
  const [step, setStep] = useState(1);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [feeSettings, setFeeSettings] = useState({
    turf_partner_fee_type: 'percentage',
    turf_partner_fee_value: '5',
  });

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/owner/fee-settings`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(res => {
      if (res.data) setFeeSettings(res.data);
    })
    .catch(err => console.error('Failed to load fee settings in AddVenueForm:', err));
  }, [token]);

  const [formData, setFormData] = useState({
    name: '',
    sports: [],

    location: '',
    city: '',
    state: '',
    pincode: '',
    description: '',
    shortDescription: '',
    price: '',
    amenities: [],
    images: [],
    videos: [],
    venueSize: 'Medium (8,000 - 12,000 sq.ft)',
    surfaceType: 'Artificial Turf',
    bookingType: 'Hourly',
    type: 'Outdoor',
    customAmenity: '',
    timings: [
      { id: 1, name: 'Monday - Friday (Weekdays)', customName: '', open: '06:00 AM', close: '10:00 PM', price: '' },
      { id: 2, name: 'Saturday - Sunday (Weekends)', customName: '', open: '06:00 AM', close: '10:00 PM', price: '' }
    ]
  });

  const [weekdaySlots, setWeekdaySlots] = useState(defaultSlotsList);
  const [weekendSlots, setWeekendSlots] = useState(defaultSlotsList);


  const steps = [
    { id: 1, label: 'Basic Details' },
    { id: 2, label: 'Venue Info' },
    { id: 3, label: 'Slots & Pricing' },
    { id: 4, label: 'Amenities' },
    { id: 5, label: 'Photos' },
    { id: 6, label: 'Review & Submit' }
  ];

  const handleNext = () => {
    if (step === 1) {
      if (!formData.name || !formData.state || !formData.city || !formData.location || formData.sports.length === 0) {
        alert('Please fill all required fields marked with *');
        return;
      }
    }
    if (step === 3) {
      const hasTimingPrice = (formData.timings || []).some(t => t.price && parseFloat(t.price) > 0);
      const hasSlotPrice = (weekdaySlots || []).some(s => s.price && parseFloat(s.price) > 0) || (weekendSlots || []).some(s => s.price && parseFloat(s.price) > 0);
      const hasBasePrice = formData.price && parseFloat(formData.price) > 0;
      if (!hasTimingPrice && !hasSlotPrice && !hasBasePrice) {
        alert('Please enter a price for at least one day schedule or slot range.');
        return;
      }
    }
    setStep(s => Math.min(s + 1, 6));
  };

  const handlePrev = () => setStep(s => Math.max(s - 1, 1));

  const handleSubmit = async () => {
    setSubmitting(true);
    setSubmitError('');
    try {
      // Validate images before sending
      if (formData.images.length === 0) {
        setSubmitError('Please upload at least one image');
        setSubmitting(false);
        return;
      }

      // Check if images are properly formatted
      const imageUrls = formData.images.map(img => {
        if (typeof img === 'object' && img.url) {
          return img.url;
        } else if (typeof img === 'string') {
          return img;
        } else {
          throw new Error('Invalid image format');
        }
      });

      console.log('Submitting venue with', imageUrls.length, 'images');

      // Extract video URLs
      const videoUrls = formData.videos.map(video => {
        if (typeof video === 'object' && video.url) {
          return video.url;
        } else if (typeof video === 'string') {
          return video;
        } else {
          throw new Error('Invalid video format');
        }
      });

      console.log('Submitting venue with', videoUrls.length, 'videos');

      // Build pricing rules array
      const wdSchedulePrice = parseFloat((formData.timings || []).find(t => t.name?.includes('Weekday') || t.name?.includes('Monday - Friday'))?.price) || 0;
      const weSchedulePrice = parseFloat((formData.timings || []).find(t => t.name?.includes('Weekend') || t.name?.includes('Saturday - Sunday'))?.price) || 0;
      const timingPriceFirst = (formData.timings || []).find(t => t.price && parseFloat(t.price) > 0)?.price;
      const slotPriceFirst = (weekdaySlots || []).find(s => s.price && parseFloat(s.price) > 0)?.price || (weekendSlots || []).find(s => s.price && parseFloat(s.price) > 0)?.price;
      const basePriceNum = parseFloat(formData.price) || parseFloat(timingPriceFirst) || parseFloat(slotPriceFirst) || 0;
      const customRangeRules = [];

      // Extract unique pricing rules from weekday slots (only if price differs from weekday schedule rate)
      weekdaySlots.forEach(s => {
        const sPrice = parseFloat(s?.price);
        const refPrice = wdSchedulePrice || basePriceNum;
        if (s && sPrice && sPrice !== refPrice) {
          const parsedRange = parseSlotRangeToMinutes(s.label);
          if (parsedRange) {
            customRangeRules.push({
              id: `rule-wd-${s.label.replace(/\s+/g, '')}`,
              category: 'Custom Slot Rate',
              type: 'Weekday',
              startTime: parsedRange.startStr || s.label.split(/ - | to /)[0],
              endTime: parsedRange.endStr || s.label.split(/ - | to /)[1],
              price: sPrice,
              active: s.isActive !== false
            });
          }
        }
      });

      // Extract unique pricing rules from weekend slots (only if price differs from weekend schedule rate)
      weekendSlots.forEach(s => {
        const sPrice = parseFloat(s?.price);
        const refPrice = weSchedulePrice || basePriceNum;
        if (s && sPrice && sPrice !== refPrice) {
          const parsedRange = parseSlotRangeToMinutes(s.label);
          if (parsedRange) {
            customRangeRules.push({
              id: `rule-we-${s.label.replace(/\s+/g, '')}`,
              category: 'Weekend Slot Rate',
              type: 'Weekend',
              startTime: parsedRange.startStr || s.label.split(/ - | to /)[0],
              endTime: parsedRange.endStr || s.label.split(/ - | to /)[1],
              price: sPrice,
              active: s.isActive !== false
            });
          }
        }
      });

      // Extract rules from day schedules with custom rates / day ranges
      (formData.timings || []).forEach(timing => {
        const schedulePrice = parseFloat(timing.price);
        if (schedulePrice && schedulePrice > 0 && schedulePrice !== basePriceNum) {
          const timingDayType = timing.name === 'Custom Days Range...' && timing.customName ? timing.customName : timing.name;
          customRangeRules.push({
            id: `rule-timing-${timing.id}`,
            category: `${timingDayType} Rate`,
            type: timingDayType,
            startTime: timing.open || '06:00 AM',
            endTime: timing.close || '10:00 PM',
            price: schedulePrice,
            active: true
          });
        }
      });

      await axios.post(`${API}/turfs`, {
        name: formData.name,
        location: formData.location,
        city: formData.city,
        state: formData.state,
        pincode: formData.pincode,
        price_per_hour: basePriceNum,
        sport: formData.sports[0] || 'Football',
        sports: formData.sports,

        venueSize: formData.venueSize,
        surfaceType: formData.surfaceType,
        bookingType: formData.bookingType,
        type: formData.type || 'Outdoor',
        description: formData.description,
        shortDescription: formData.shortDescription,
        amenities: formData.amenities,
        images: imageUrls,
        videos: videoUrls,
        timings: formData.timings,
        pricingRules: [
          {
            id: 'turf_slots_config',
            type: 'slots_config',
            weekdaySlots: weekdaySlots,
            weekendSlots: weekendSlots,
            timings: formData.timings,
            weekdayHours: { open: formData.timings?.[0]?.open || '06:00 AM', close: formData.timings?.[0]?.close || '10:00 PM' },
            weekendHours: { open: formData.timings?.[1]?.open || '06:00 AM', close: formData.timings?.[1]?.close || '10:00 PM' }
          },
          ...customRangeRules
        ],
      }, { headers: { Authorization: `Bearer ${token}` } });
      onComplete?.();
    } catch (err) {
      console.error('❌ Submit venue error:', err);
      console.error('Error response:', err.response?.data);
      
      let errorMsg = 'Failed to submit venue. Please try again.';
      
      if (err.response?.data?.msg) {
        errorMsg = err.response.data.msg;
      } else if (err.response?.data?.error) {
        errorMsg = err.response.data.error;
      } else if (err.message) {
        errorMsg = err.message;
      }
      
      setSubmitError(errorMsg);
      setSubmitting(false);
    }
  };

  return (
    <div className="add-venue-container">
      {/* HEADER */}
      <div className="add-venue-header">
        <button onClick={onCancel} className="back-venues-btn">
          <ChevronLeft size={18} /> Back to Venues
        </button>
        <div className="header-title-block">
          <div className="badge-venue-wizard">✨ Partner Venue Wizard</div>
          <h2 className="venue-page-title">Add New Sports Venue</h2>
        </div>
        <div className="step-counter-pill">
          Step <span>{step}</span> of 6
        </div>
      </div>

      {/* MODERN STEPPER */}
      <div className="stepper-container">
        <div className="stepper-line"></div>
        <div className="stepper-line-progress" style={{ width: `${((step - 1) / 5) * 100}%` }}></div>
        {steps.map((s, i) => (
          <div 
            key={s.id} 
            className={`stepper-step ${step === s.id ? 'active' : ''} ${step > s.id ? 'completed' : ''}`}
            onClick={() => { if (step > s.id) setStep(s.id); }}
            style={{ cursor: step > s.id ? 'pointer' : 'default' }}
          >
            <div className="step-circle">
              {step > s.id ? <Check size={18} strokeWidth={2.8} /> : s.id}
            </div>
            <span className="step-label">{s.label}</span>
          </div>
        ))}
      </div>

      {/* FORM CONTENT */}
      <div className="form-card">
        {step === 1 && <BasicDetails formData={formData} setFormData={setFormData} />}
        {step === 2 && <VenueInfo formData={formData} setFormData={setFormData} />}
        {step === 3 && <SlotsPricing formData={formData} setFormData={setFormData} feeSettings={feeSettings} weekdaySlots={weekdaySlots} setWeekdaySlots={setWeekdaySlots} weekendSlots={weekendSlots} setWeekendSlots={setWeekendSlots} />}
        {step === 4 && <AmenitiesSection formData={formData} setFormData={setFormData} />}
        {step === 5 && <PhotosUpload formData={formData} setFormData={setFormData} token={token} />}
        {step === 6 && <ReviewSubmit formData={formData} weekdaySlots={weekdaySlots} weekendSlots={weekendSlots} onEdit={(s) => setStep(s)} />}

        {submitError && (
          <div style={{ marginTop: '1.5rem', padding: '14px 18px', borderRadius: '14px', background: '#FEF2F2', border: '1.5px solid #FCA5A5', color: '#B91C1C', fontWeight: '700', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <AlertCircle size={18} /> {submitError}
          </div>
        )}

        {/* FOOTER ACTIONS */}
        <div className="form-footer-actions">
           <button 
             onClick={handlePrev} 
             className="btn-prev-step"
             style={{ visibility: step === 1 ? 'hidden' : 'visible' }}
           >
             <ChevronLeft size={18} /> Previous Step
           </button>
           <button 
             onClick={step === 6 ? handleSubmit : handleNext}
             disabled={submitting}
             className="btn-next-step"
           >
             {step === 6 ? (submitting ? 'Submitting Venue...' : 'Complete & Submit Venue') : 'Save & Continue'} {!submitting && <ChevronRight size={18} />}
           </button>
        </div>
      </div>

      <style>{`
        .add-venue-container {
          max-width: 1100px;
          margin: 0 auto;
          padding: 10px 16px 40px;
          animation: fadeIn 0.4s ease-out;
        }
        .add-venue-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 2.2rem;
          flex-wrap: wrap;
          gap: 1rem;
        }
        .back-venues-btn {
          background: #F8FAF7;
          border: 1.5px solid #E2EAD8;
          color: #084734;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
          font-weight: 750;
          font-size: 0.88rem;
          padding: 8px 16px;
          border-radius: 12px;
          transition: all 0.2s ease;
        }
        .back-venues-btn:hover {
          background: #EEF7E2;
          border-color: #CEF17B;
          transform: translateX(-2px);
        }
        .header-title-block {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .badge-venue-wizard {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          background: #DCEFB8;
          color: #084734;
          font-size: 0.72rem;
          font-weight: 800;
          padding: 3px 10px;
          border-radius: 20px;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          width: fit-content;
        }
        .venue-page-title {
          font-size: 1.6rem;
          font-weight: 900;
          color: #0F172A;
          margin: 0;
          letter-spacing: -0.5px;
        }
        .step-counter-pill {
          background: #F1F5F9;
          color: #64748B;
          font-size: 0.82rem;
          font-weight: 700;
          padding: 6px 14px;
          border-radius: 20px;
        }
        .step-counter-pill span {
          color: #084734;
          font-weight: 900;
        }
        @media (max-width: 640px) {
          .add-venue-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
            margin-bottom: 1.5rem;
          }
          .venue-page-title {
            font-size: 1.3rem;
          }
        }
        .stepper-container {
          display: flex;
          justify-content: space-between;
          position: relative;
          margin-bottom: 2.5rem;
          padding: 0 10px;
        }
        .stepper-line {
          position: absolute;
          top: 18px;
          left: 30px;
          right: 30px;
          height: 3px;
          background: #E2EAD8;
          z-index: 1;
          border-radius: 3px;
        }
        .stepper-line-progress {
          position: absolute;
          top: 18px;
          left: 30px;
          height: 3px;
          background: linear-gradient(90deg, #084734 0%, #10B981 50%, #CEF17B 100%);
          z-index: 1;
          border-radius: 3px;
          transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .stepper-step {
          position: relative;
          z-index: 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          transition: transform 0.2s ease;
        }
        .stepper-step:hover {
          transform: translateY(-2px);
        }
        .step-circle {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background: white;
          border: 2.5px solid #E2EAD8;
          color: #64748B;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 850;
          font-size: 0.9rem;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        }
        .stepper-step.active .step-circle {
          background: #084734;
          border-color: #CEF17B;
          color: #CEF17B;
          box-shadow: 0 0 0 4px rgba(206, 241, 123, 0.35), 0 4px 12px rgba(8, 71, 52, 0.2);
        }
        .stepper-step.completed .step-circle {
          background: #10B981;
          border-color: #10B981;
          color: white;
          box-shadow: 0 2px 8px rgba(16, 185, 129, 0.25);
        }
        .step-label {
          font-size: 0.78rem;
          font-weight: 750;
          color: #64748B;
          transition: color 0.2s;
        }
        .stepper-step.active .step-label {
          color: #084734;
          font-weight: 850;
        }
        .stepper-step.completed .step-label {
          color: #10B981;
        }
        @media (max-width: 850px) {
          .step-label {
            display: none !important;
          }
          .stepper-container {
            margin-bottom: 1.8rem;
          }
        }
        .form-card {
          background: white;
          border-radius: 24px;
          padding: 3rem;
          border: 1.5px solid #E2EAD8;
          box-shadow: 0 12px 35px -10px rgba(8, 71, 52, 0.08);
          position: relative;
        }
        .form-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 24px;
          right: 24px;
          height: 4px;
          border-radius: 4px 4px 0 0;
          background: linear-gradient(90deg, #084734 0%, #CEF17B 100%);
        }
        @media (max-width: 768px) {
          .form-card {
            padding: 1.5rem !important;
            border-radius: 20px;
          }
        }
        .btn-prev-step {
          padding: 13px 26px;
          border-radius: 12px;
          border: 1.5px solid #E2EAD8;
          background: #F8FAF7;
          font-weight: 750;
          font-size: 0.9rem;
          cursor: pointer;
          color: #374151;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s;
        }
        .btn-prev-step:hover {
          background: #EEF2E6;
          border-color: #CBD5E1;
        }
        .btn-next-step {
          padding: 14px 38px;
          border-radius: 12px;
          border: none;
          background: linear-gradient(135deg, #084734 0%, #0d5f47 100%);
          color: #CEF17B;
          font-weight: 850;
          font-size: 0.92rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 10px;
          box-shadow: 0 6px 20px rgba(8, 71, 52, 0.25);
          transition: all 0.25s ease;
        }
        .btn-next-step:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(8, 71, 52, 0.35);
          background: linear-gradient(135deg, #053325 0%, #084734 100%);
        }
        .btn-next-step:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        .main-form-grid {
          display: grid;
          grid-template-columns: 1.3fr 1fr;
          gap: 4.5rem;
        }
        @media (max-width: 1024px) {
          .main-form-grid {
            grid-template-columns: 1fr;
            gap: 2rem;
          }
        }
        .grid-2-col {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1.5rem;
        }
        @media (max-width: 640px) {
          .grid-2-col {
            grid-template-columns: 1fr;
            gap: 1rem;
          }
        }
        .location-row {
          display: flex;
          gap: 10px;
          align-items: flex-start;
        }
        @media (max-width: 640px) {
          .location-row {
            flex-direction: column;
            align-items: stretch;
          }
          .location-row button {
            justify-content: center;
            width: 100%;
          }
        }
        .amenities-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 15px;
          margin-bottom: 2.5rem;
        }
        @media (max-width: 900px) {
          .amenities-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }
        @media (max-width: 640px) {
          .amenities-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }
        }
        @media (max-width: 400px) {
          .amenities-grid {
            grid-template-columns: 1fr;
          }
        }
        .photos-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1.5rem;
          margin-bottom: 1.5rem;
        }
        @media (max-width: 900px) {
          .photos-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }
        @media (max-width: 640px) {
          .photos-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 1rem;
          }
        }
        @media (max-width: 400px) {
          .photos-grid {
            grid-template-columns: 1fr;
          }
        }
        .videos-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.5rem;
          margin-bottom: 1.5rem;
        }
        @media (max-width: 768px) {
          .videos-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 1rem;
          }
        }
        @media (max-width: 480px) {
          .videos-grid {
            grid-template-columns: 1fr;
          }
        }
        .guidelines-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 2rem;
        }
        @media (max-width: 768px) {
          .guidelines-grid {
            grid-template-columns: 1fr;
            gap: 1rem;
          }
        }
        .review-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 2.5rem;
        }
        @media (max-width: 768px) {
          .review-grid {
            grid-template-columns: 1fr;
            gap: 1.5rem;
          }
        }
        .form-footer-actions {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 3.5rem;
          border-top: 1.5px solid #EEF2E6;
          padding-top: 2.5rem;
          gap: 12px;
        }
        @media (max-width: 480px) {
          .form-footer-actions {
            flex-direction: column;
            align-items: stretch;
            margin-top: 2rem;
            padding-top: 1.5rem;
          }
          .form-footer-actions button {
            width: 100%;
            justify-content: center;
            padding: 12px 20px !important;
          }
        }
        .timings-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 2px;
        }
        @media (max-width: 768px) {
          .timings-row {
            flex-direction: column;
            align-items: stretch;
            gap: 8px;
          }
          .timings-row span {
            text-align: center;
          }
        }
      `}</style>
    </div>
  );
}

function BasicDetails({ formData, setFormData }) {
  const [gettingLocation, setGettingLocation] = useState(false);

  const handleGetLocation = () => {
    setGettingLocation(true);
    if (!navigator.geolocation) {
      alert('Geolocation is not supported by your browser');
      setGettingLocation(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        let detectedCity = '';
        let detectedState = '';
        let detectedPostcode = '';
        let detectedLandmark = '';

        // 1. First attempt OpenStreetMap Nominatim for highly detailed landmarks & address components
        try {
          const nomRes = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`,
            { headers: { 'Accept-Language': 'en' } }
          );
          if (nomRes.ok) {
            const nomData = await nomRes.json();
            const addr = nomData.address || {};
            
            const street = addr.road || addr.pedestrian || addr.street || addr.footway || '';
            const subArea = addr.suburb || addr.neighbourhood || addr.quarter || addr.residential || addr.commercial || addr.subdistrict || '';
            const locality = addr.city_district || addr.district || addr.county || '';
            
            const landmarkParts = [street, subArea, locality].filter(Boolean);
            if (landmarkParts.length > 0) {
              detectedLandmark = landmarkParts.join(', ');
            } else if (nomData.display_name) {
              detectedLandmark = nomData.display_name.split(',').slice(0, 2).join(', ').trim();
            }

            detectedCity = addr.city || addr.town || addr.village || addr.municipality || addr.state_district || '';
            detectedState = addr.state || addr.province || '';
            detectedPostcode = addr.postcode ? String(addr.postcode).replace(/\D/g, '').slice(0, 6) : '';
          }
        } catch (e) {
          console.warn('Nominatim reverse geocode error:', e);
        }

        // 2. Fallback or augment with BigDataCloud API
        if (!detectedState || !detectedCity || !detectedLandmark) {
          try {
            const bdcRes = await fetch(
              `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
            );
            if (bdcRes.ok) {
              const bdcData = await bdcRes.json();
              if (!detectedCity) detectedCity = bdcData.city || bdcData.locality || '';
              if (!detectedState) detectedState = bdcData.principalSubdivision || '';
              if (!detectedPostcode && bdcData.postcode) {
                detectedPostcode = String(bdcData.postcode).replace(/\D/g, '').slice(0, 6);
              }
              if (!detectedLandmark) {
                const bdcLocality = bdcData.locality || bdcData.localityInfo?.informative?.[0]?.name || '';
                const bdcAdmin = bdcData.localityInfo?.administrative?.[0]?.name || '';
                detectedLandmark = [bdcLocality, bdcAdmin].filter(Boolean).join(', ') || bdcData.locality || '';
              }
            }
          } catch (e) {
            console.warn('BigDataCloud reverse geocode error:', e);
          }
        }

        // 3. Match State against LOCATION_DATA / STATE_CITY_PINCODES
        let matchedState = '';
        if (detectedState) {
          const stateKeys = Object.keys(LOCATION_DATA);
          const directMatch = stateKeys.find(s => s.toLowerCase() === detectedState.toLowerCase());
          if (directMatch) {
            matchedState = directMatch;
          } else {
            const subMatch = stateKeys.find(s => 
              s.toLowerCase().includes(detectedState.toLowerCase()) || 
              detectedState.toLowerCase().includes(s.toLowerCase())
            );
            if (subMatch) matchedState = subMatch;
          }
        }

        // 4. Match City
        let matchedCity = '';
        if (matchedState && LOCATION_DATA[matchedState]) {
          const citiesInState = LOCATION_DATA[matchedState];
          const directCity = citiesInState.find(c => c.toLowerCase() === detectedCity.toLowerCase());
          if (directCity) {
            matchedCity = directCity;
          } else {
            const subCity = citiesInState.find(c => 
              c.toLowerCase().includes(detectedCity.toLowerCase()) || 
              detectedCity.toLowerCase().includes(c.toLowerCase())
            );
            if (subCity) matchedCity = subCity;
          }
        }

        // If state was not matched directly but city is found in some state
        if (!matchedState && detectedCity) {
          for (const s of Object.keys(LOCATION_DATA)) {
            const match = LOCATION_DATA[s].find(c => c.toLowerCase() === detectedCity.toLowerCase() || detectedCity.toLowerCase().includes(c.toLowerCase()));
            if (match) {
              matchedState = s;
              matchedCity = match;
              break;
            }
          }
        }

        // 5. Determine accurate 6-digit Pincode
        let finalPincode = '';
        if (detectedPostcode && /^\d{6}$/.test(detectedPostcode)) {
          finalPincode = detectedPostcode;
        } else if (matchedState && matchedCity) {
          finalPincode = getCityPincode(matchedState, matchedCity);
        } else if (matchedState) {
          finalPincode = getCityPincode(matchedState, '');
        }

        const finalLandmark = detectedLandmark || (matchedCity ? `${matchedCity} Central` : 'Current Location');
        const finalState = matchedState || detectedState || 'Karnataka';
        const finalCity = matchedCity || (LOCATION_DATA[finalState] ? LOCATION_DATA[finalState][0] : detectedCity);

        setFormData(prev => ({
          ...prev,
          location: finalLandmark,
          state: finalState,
          city: finalCity,
          pincode: finalPincode || prev.pincode || '560001'
        }));

        if (finalState && LOCATION_DATA[finalState]) {
          setAvailableCities(LOCATION_DATA[finalState]);
        }

        setGettingLocation(false);
      },
      (error) => {
        console.error('Geolocation error:', error);
        alert(`Error getting location: ${error.message}`);
        setGettingLocation(false);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  };

  const [availableCities, setAvailableCities] = useState([]);

  useEffect(() => {
    if (formData.state) {
      setAvailableCities(LOCATION_DATA[formData.state] || []);
    }
  }, [formData.state]);

  const [customSportsList, setCustomSportsList] = useState([]);
  const [showAddCustomSport, setShowAddCustomSport] = useState(false);
  const [customSportName, setCustomSportName] = useState('');

  const handleSportToggle = (sport) => {
    const sports = formData.sports.includes(sport)
      ? formData.sports.filter(s => s !== sport)
      : [...formData.sports, sport];
    setFormData({ ...formData, sports });
  };

  const handleAddCustomSport = (e) => {
    if (e) e.preventDefault();
    const trimmed = customSportName.trim();
    if (!trimmed) return;
    if (!customSportsList.includes(trimmed) && !SPORTS_LIST.includes(trimmed)) {
      setCustomSportsList(prev => [...prev, trimmed]);
    }
    if (!formData.sports.includes(trimmed)) {
      setFormData(prev => ({ ...prev, sports: [...prev.sports, trimmed] }));
    }
    setCustomSportName('');
    setShowAddCustomSport(false);
  };

  const allAvailableSports = Array.from(new Set([...SPORTS_LIST, ...customSportsList, ...(formData.sports || [])]));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
      <SectionHeader icon={<Info size={20} />} title="Basic Details" subtitle="Enter the core information about your sports venue" />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
        <Field label="Venue Name *">
          <input 
            type="text" 
            placeholder="e.g. Green Turf Arena" 
            value={formData.name}
            onChange={(e) => setFormData({...formData, name: e.target.value})}
            style={inputStyle} 
          />
        </Field>

        <Field label="Venue Type *">
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {['Outdoor', 'Indoor', 'Indoor + Outdoor'].map(t => (
              <div 
                key={t}
                onClick={() => setFormData({ ...formData, type: t })}
                style={{ 
                  padding: '10px 20px', borderRadius: '12px', border: '1.5px solid',
                  borderColor: (formData.type || 'Outdoor') === t ? '#CEF17B' : '#EEF2E6',
                  background: (formData.type || 'Outdoor') === t ? '#DCEFB8' : 'white',
                  color: (formData.type || 'Outdoor') === t ? '#084734' : '#374151',
                  fontSize: '0.88rem', fontWeight: '700', cursor: 'pointer', transition: 'all 0.2s',
                  boxShadow: (formData.type || 'Outdoor') === t ? '0 4px 12px rgba(8,71,52,0.08)' : 'none'
                }}
              >
                {t}
              </div>
            ))}
          </div>
        </Field>

        <Field label="Sports Offered *">
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }}>
            {allAvailableSports.map(sport => (
              <div 
                key={sport}
                onClick={() => handleSportToggle(sport)}
                style={{ 
                  padding: '10px 18px', borderRadius: '10px', border: '1.5px solid',
                  borderColor: formData.sports.includes(sport) ? '#CEF17B' : '#DCEFB8',
                  background: formData.sports.includes(sport) ? '#DCEFB8' : 'white',
                  color: formData.sports.includes(sport) ? '#084734' : '#374151',
                  fontSize: '0.85rem', fontWeight: '700', cursor: 'pointer', transition: '0.2s'
                }}
              >
                {sport}
              </div>
            ))}

            {showAddCustomSport ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <input
                  type="text"
                  placeholder="Enter sport name"
                  value={customSportName}
                  onChange={(e) => setCustomSportName(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleAddCustomSport();
                    }
                  }}
                  autoFocus
                  style={{
                    padding: '8px 12px',
                    borderRadius: '10px',
                    border: '1.5px solid #084734',
                    fontSize: '0.85rem',
                    fontWeight: '700',
                    outline: 'none',
                    background: '#FFFFFF'
                  }}
                />
                <button
                  type="button"
                  onClick={handleAddCustomSport}
                  style={{
                    padding: '8px 14px',
                    borderRadius: '8px',
                    background: '#084734',
                    color: '#CEF17B',
                    border: 'none',
                    fontWeight: '800',
                    fontSize: '0.8rem',
                    cursor: 'pointer'
                  }}
                >
                  Add
                </button>
                <button
                  type="button"
                  onClick={() => { setShowAddCustomSport(false); setCustomSportName(''); }}
                  style={{
                    padding: '8px 12px',
                    borderRadius: '8px',
                    background: '#F1F5F9',
                    color: '#64748B',
                    border: 'none',
                    fontWeight: '700',
                    fontSize: '0.8rem',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
              </div>
            ) : (
              <button
                type="button"
                onClick={() => setShowAddCustomSport(true)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '9px 16px',
                  borderRadius: '10px',
                  border: '1.5px dashed #084734',
                  background: '#F0FDF4',
                  color: '#084734',
                  fontSize: '0.85rem',
                  fontWeight: '800',
                  cursor: 'pointer'
                }}
              >
                <Plus size={15} /> Add Sport
              </button>
            )}
          </div>
        </Field>

        <Field label="Location / Landmark *">
          <div className="location-row">
            <div style={{ position: 'relative', flex: 1 }}>
              <MapPin size={18} style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#374151' }} />
              <input 
                type="text" 
                placeholder="Enter locality or nearby landmark" 
                value={formData.location}
                onChange={(e) => setFormData({...formData, location: e.target.value})}
                style={{ ...inputStyle, paddingLeft: '48px' }} 
              />
            </div>
            <button
              onClick={handleGetLocation}
              disabled={gettingLocation}
              style={{
                padding: '10px 16px',
                borderRadius: '10px',
                background: '#CEF17B',
                color: '#084734',
                border: 'none',
                fontWeight: '700',
                cursor: gettingLocation ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                whiteSpace: 'nowrap'
              }}
            >
              {gettingLocation ? 'Getting...' : 'Use My Location'}
            </button>
          </div>
        </Field>

        <div className="grid-2-col">
          <Field label="State *">
            <div style={{ position: 'relative', width: '100%' }}>
              <select 
                style={{ ...inputStyle, paddingRight: '40px', cursor: 'pointer' }}
                value={formData.state}
                onChange={(e) => setFormData({...formData, state: e.target.value, city: ''})}
              >
                <option value="">Select State</option>
                {Object.keys(LOCATION_DATA).map(s => <option key={s} value={s}>{s}</option>)}
              </select>
              <div style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#084734', display: 'flex', alignItems: 'center' }}>
                <ChevronDown size={18} />
              </div>
            </div>
          </Field>
          <Field label="City *">
            <div style={{ position: 'relative', width: '100%' }}>
              <select 
                style={{ ...inputStyle, paddingRight: '40px', cursor: 'pointer' }}
                value={formData.city}
                onChange={(e) => {
                  const city = e.target.value;
                  const pincode = getCityPincode(formData.state, city);
                  setFormData({...formData, city, pincode});
                }}
                disabled={!formData.state}
              >
                <option value="">Select City</option>
                {availableCities.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
              <div style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#084734', display: 'flex', alignItems: 'center' }}>
                <ChevronDown size={18} />
              </div>
            </div>
          </Field>
        </div>
        <Field label="Pincode">
          <input 
            type="text" 
            placeholder="Enter 6-digit pincode" 
            value={formData.pincode}
            onChange={(e) => setFormData({...formData, pincode: e.target.value.replace(/\D/g, '').slice(0, 6)})}
            style={inputStyle}
            maxLength={6}
            inputMode="numeric"
          />
        </Field>
      </div>
      <div style={{ background: '#F8FAF7', borderRadius: '24px', border: '1.5px solid #EEF2E6', padding: '1.5rem' }}>
        <h4 style={{ fontSize: '0.9rem', fontWeight: '800', marginBottom: '1rem', color: '#161616' }}>Pro Tip</h4>
        <p style={{ fontSize: '0.85rem', color: '#374151', lineHeight: 1.6, fontWeight: '500' }}>
          Venues with accurate location details and landmarks get **30% more bookings** as it helps players find you easily.
        </p>
      </div>
    </div>
  );
}

function VenueInfo({ formData, setFormData }) {
  return (
    <div className="main-form-grid">
       <div>
          <SectionHeader icon={<Info size={20} />} title="Venue Information" subtitle="Provide technical and descriptive details about your facility" />
          
          <div className="grid-2-col" style={{ marginBottom: '2rem' }}>
             <Field label="Venue Size *">
               <div style={{ position: 'relative', width: '100%' }}>
                 <select 
                   style={{ ...inputStyle, paddingRight: '40px', cursor: 'pointer' }}
                   value={formData.venueSize}
                   onChange={(e) => setFormData({...formData, venueSize: e.target.value})}
                 >
                   <option>Small (Below 8,000 sq.ft)</option>
                   <option>Medium (8,000 - 12,000 sq.ft)</option>
                   <option>Large (Above 12,000 sq.ft)</option>
                 </select>
                 <div style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#084734', display: 'flex', alignItems: 'center' }}>
                   <ChevronDown size={18} />
                 </div>
               </div>
             </Field>
             <Field label="Surface Type *">
                <div style={{ position: 'relative', width: '100%' }}>
                  <select 
                    style={{ ...inputStyle, paddingRight: '40px', cursor: 'pointer' }}
                    value={formData.surfaceType}
                    onChange={(e) => setFormData({...formData, surfaceType: e.target.value})}
                  >
                    <option>Artificial Turf</option>
                    <option>Natural Grass</option>
                    <option>Wooden Court</option>
                    <option>Synthetic Court</option>
                    <option>Concrete</option>
                  </select>
                  <div style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#084734', display: 'flex', alignItems: 'center' }}>
                    <ChevronDown size={18} />
                  </div>
                </div>
             </Field>
          </div>

          <Field label="Short Description (Max 150 chars) *">
             <textarea 
               style={{ ...inputStyle, height: '90px', resize: 'none' }} 
               maxLength={150} 
               placeholder="Briefly describe your venue to catch attention..."
               value={formData.shortDescription}
               onChange={(e) => setFormData({...formData, shortDescription: e.target.value})}
             ></textarea>
             <div style={{ textAlign: 'right', fontSize: '0.75rem', color: '#374151', marginTop: '6px', fontWeight: '600' }}>{formData.shortDescription.length}/150</div>
          </Field>

          <Field label="Venue Rules">
             <textarea 
               style={{ ...inputStyle, height: '180px', resize: 'none', marginTop: '1.5rem' }} 
               maxLength={1000}
               placeholder="Enter rules for the venue (e.g. non-marking shoes only, no food on turf, arrive 10 mins early)..."
               value={formData.description}
               onChange={(e) => setFormData({...formData, description: e.target.value})}
             ></textarea>
             <div style={{ textAlign: 'right', fontSize: '0.75rem', color: '#374151', marginTop: '6px', fontWeight: '600' }}>{formData.description.length}/1000</div>
          </Field>
       </div>

       <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          <div style={{ background: 'white', borderRadius: '24px', border: '1.5px solid #EEF2E6', padding: '2rem' }}>
             <SectionHeader icon={<ShieldCheck size={20} />} title="Operational Policies" small />
             <div style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
                {[
                  { key: 'outsideFood', label: 'Outside Food Allowed' },
                  { key: 'petsAllowed', label: 'Pets Allowed' },
                  { key: 'changingRooms', label: 'Changing Rooms Available' }
                ].map(policy => {
                  const isEnabled = formData[policy.key] || false;
                  return (
                    <div key={policy.key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                       <span style={{ fontSize: '0.9rem', fontWeight: '600', color: '#374151' }}>{policy.label}</span>
                       <div 
                         onClick={() => setFormData({...formData, [policy.key]: !isEnabled})}
                         style={{ 
                           width: '40px', 
                           height: '22px', 
                           background: isEnabled ? '#CEF17B' : '#DCEFB8', 
                           borderRadius: '20px', 
                           padding: '2px', 
                           cursor: 'pointer', 
                           position: 'relative',
                           transition: 'background 0.3s'
                         }}
                       >
                          <div style={{ 
                            width: '18px', 
                            height: '18px', 
                            background: 'white', 
                            borderRadius: '50%', 
                            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                            transform: isEnabled ? 'translateX(18px)' : 'translateX(0)',
                            transition: 'transform 0.3s'
                          }}></div>
                       </div>
                    </div>
                  );
                })}
             </div>
          </div>
          
          <div style={{ background: '#DCEFB8', borderRadius: '24px', padding: '2rem', border: '1.5px solid #DCEFB8' }}>
             <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '1rem', color: '#084734' }}>
                <Star size={20} />
                <h4 style={{ fontWeight: '800', fontSize: '1rem' }}>Success Rating</h4>
             </div>
             <p style={{ fontSize: '0.85rem', color: '#084734', fontWeight: '600', lineHeight: 1.6 }}>
               Venues with detailed descriptions and clear policies get **45% fewer cancellations**.
             </p>
          </div>
       </div>
    </div>
  );
}

function SlotsPricing({ formData, setFormData, feeSettings, weekdaySlots = [], setWeekdaySlots, weekendSlots = [], setWeekendSlots }) {
  const [showAddSlotForm, setShowAddSlotForm] = useState(false);
  const [newSlotStart, setNewSlotStart] = useState('06:00 AM');
  const [newSlotEnd, setNewSlotEnd] = useState('06:00 PM');
  const [newSlotPrice, setNewSlotPrice] = useState('');
  const [newSlotTarget, setNewSlotTarget] = useState('both');
  const [newSlotMode, setNewSlotMode] = useState('generate_hourly'); // 'generate_hourly' | 'apply_range_price' | 'single_custom'
  const [overlapWarning, setOverlapWarning] = useState(null);
  const [editingSlotPriceKey, setEditingSlotPriceKey] = useState(null);
  const [inlinePriceVal, setInlinePriceVal] = useState('');

  const normalizeSlot = (s) => {
    if (typeof s === 'string') return { label: s, isActive: true, price: parseFloat(formData.price) || 0 };
    return {
      label: s.label || s.slot || '',
      isActive: s.isActive !== false,
      price: s.price !== undefined ? parseFloat(s.price) : (parseFloat(formData.price) || 0)
    };
  };

  const toggleSlotActiveState = (targetSlot, isWeekday) => {
    const normTarget = normalizeSlot(targetSlot);
    const setter = isWeekday ? setWeekdaySlots : setWeekendSlots;
    setter(prev => prev.map(s => {
      const norm = normalizeSlot(s);
      if (norm.label === normTarget.label) {
        return { ...norm, isActive: !norm.isActive };
      }
      return norm;
    }));
  };

  const removeSlotPermanently = (targetSlot, isWeekday) => {
    const normTarget = normalizeSlot(targetSlot);
    const setter = isWeekday ? setWeekdaySlots : setWeekendSlots;
    setter(prev => prev.filter(s => normalizeSlot(s).label !== normTarget.label));
  };

  const updateIndividualSlotPrice = (targetSlot, newPrice, isWeekday) => {
    const normTarget = normalizeSlot(targetSlot);
    const numPrice = parseFloat(newPrice) || 0;
    const setter = isWeekday ? setWeekdaySlots : setWeekendSlots;
    setter(prev => prev.map(s => {
      const norm = normalizeSlot(s);
      if (norm.label === normTarget.label) {
        return { ...norm, price: numPrice };
      }
      return norm;
    }));
    setEditingSlotPriceKey(null);
  };

  const checkSlotOverlap = (newSlotStr, existingSlots) => {
    const newRange = parseSlotRangeToMinutes(newSlotStr);
    if (!newRange) return null;

    for (const slotItem of existingSlots) {
      const slotStr = typeof slotItem === 'string' ? slotItem : (slotItem?.label || slotItem?.slot || '');
      const existingRange = parseSlotRangeToMinutes(slotStr);
      if (!existingRange) continue;

      if (newRange.start < existingRange.end && existingRange.start < newRange.end) {
        return slotStr;
      }
    }
    return null;
  };

  const syncTimingScheduleFromConfig = (target, startStr, endStr, price) => {
    let dayRangeName = 'Monday - Friday (Weekdays)';
    if (target === 'weekend' || target === 'sat-sun') {
      dayRangeName = 'Saturday - Sunday (Weekends)';
    } else if (target === 'both' || target === 'all-days') {
      dayRangeName = 'All Days (Monday - Sunday)';
    } else if (target === 'mon-wed') {
      dayRangeName = 'Monday - Wednesday';
    } else if (target === 'thu-fri') {
      dayRangeName = 'Thursday - Friday';
    } else if (target === 'mon-sat') {
      dayRangeName = 'Monday - Saturday';
    } else {
      const matchOpt = DAY_RANGE_OPTIONS.find(d => d.id === target || d.label === target);
      if (matchOpt) dayRangeName = matchOpt.label;
    }

    setFormData(prev => {
      const list = [...(prev.timings || [])];
      const matchIdx = list.findIndex(t => t.name === dayRangeName);
      if (matchIdx >= 0) {
        list[matchIdx] = {
          ...list[matchIdx],
          open: startStr,
          close: endStr,
          price: price ? String(price) : list[matchIdx].price
        };
      } else {
        list.push({
          id: list.length + 1,
          name: dayRangeName,
          customName: '',
          open: startStr,
          close: endStr,
          price: price ? String(price) : ''
        });
      }
      return { ...prev, timings: list };
    });
  };

  const handleApplySlotRangeOrBuilder = (forceAdd = false) => {
    const startStr = newSlotStart.trim();
    const endStr = newSlotEnd.trim();
    if (!startStr || !endStr) return;

    const basePriceNum = parseFloat(formData.price) || 0;
    const priceToSet = newSlotPrice ? parseFloat(newSlotPrice) : basePriceNum;

    // Sync to Operational Days & Schedule
    syncTimingScheduleFromConfig(newSlotTarget, startStr, endStr, priceToSet);

    if (newSlotMode === 'apply_range_price') {
      // Apply price to any existing slots that fall within the range
      const rangeMins = parseSlotRangeToMinutes(`${startStr} - ${endStr}`);
      if (!rangeMins) return;

      const updateList = (prev) => prev.map(s => {
        const norm = normalizeSlot(s);
        const slotMins = parseSlotRangeToMinutes(norm.label);
        if (slotMins && slotMins.start >= rangeMins.start && slotMins.end <= rangeMins.end) {
          return { ...norm, price: priceToSet };
        }
        return norm;
      });

      if (newSlotTarget === 'weekday' || newSlotTarget === 'both' || newSlotTarget === 'mon-fri' || newSlotTarget === 'mon-wed') {
        setWeekdaySlots?.(updateList);
      }
      if (newSlotTarget === 'weekend' || newSlotTarget === 'both' || newSlotTarget === 'sat-sun') {
        setWeekendSlots?.(updateList);
      }
      setShowAddSlotForm(false);
      setOverlapWarning(null);
      return;
    }

    if (newSlotMode === 'generate_hourly') {
      // Generate 1-hour slots across the range with custom price
      const generated = generateSlotsFromRange(startStr, endStr, priceToSet, 60);

      const updateWithGenerated = (prev) => {
        const currentNorm = prev.map(normalizeSlot);
        const merged = [...currentNorm];
        generated.forEach(gen => {
          const existingIdx = merged.findIndex(m => m.label === gen.label);
          if (existingIdx >= 0) {
            merged[existingIdx] = { ...merged[existingIdx], price: gen.price, isActive: true };
          } else {
            merged.push(gen);
          }
        });
        return sortAndDeduplicateSlots(merged, basePriceNum);
      };

      if (newSlotTarget === 'weekday' || newSlotTarget === 'both' || newSlotTarget === 'mon-fri' || newSlotTarget === 'mon-wed') {
        setWeekdaySlots?.(updateWithGenerated);
      }
      if (newSlotTarget === 'weekend' || newSlotTarget === 'both' || newSlotTarget === 'sat-sun') {
        setWeekendSlots?.(updateWithGenerated);
      }
      setShowAddSlotForm(false);
      setOverlapWarning(null);
      return;
    }

    // Otherwise single custom slot mode
    const slotLabel = `${startStr} - ${endStr}`;
    if (!forceAdd) {
      let overlapping = null;
      if (newSlotTarget === 'weekday' || newSlotTarget === 'both') {
        overlapping = checkSlotOverlap(slotLabel, weekdaySlots);
      }
      if (!overlapping && (newSlotTarget === 'weekend' || newSlotTarget === 'both')) {
        overlapping = checkSlotOverlap(slotLabel, weekendSlots);
      }

      if (overlapping) {
        setOverlapWarning({
          slotLabel,
          overlappingSlot: overlapping,
          target: newSlotTarget
        });
        return;
      }
    }

    const slotObj = { label: slotLabel, isActive: true, price: priceToSet };

    if (newSlotTarget === 'weekday' || newSlotTarget === 'both') {
      setWeekdaySlots?.(prev => {
        const normList = prev.map(normalizeSlot);
        const idx = normList.findIndex(s => s.label === slotLabel);
        if (idx >= 0) {
          normList[idx] = slotObj;
          return sortAndDeduplicateSlots(normList, basePriceNum);
        }
        return sortAndDeduplicateSlots([...normList, slotObj], basePriceNum);
      });
    }
    if (newSlotTarget === 'weekend' || newSlotTarget === 'both') {
      setWeekendSlots?.(prev => {
        const normList = prev.map(normalizeSlot);
        const idx = normList.findIndex(s => s.label === slotLabel);
        if (idx >= 0) {
          normList[idx] = slotObj;
          return sortAndDeduplicateSlots(normList, basePriceNum);
        }
        return sortAndDeduplicateSlots([...normList, slotObj], basePriceNum);
      });
    }

    setOverlapWarning(null);
    setShowAddSlotForm(false);
  };

  const handleTimingChange = (item, field, val) => {
    const updated = (formData.timings || []).map(t => {
      if (t.id === item.id) {
        const next = { ...t, [field]: val };
        if (field === 'name' && val === 'Custom Days Range...' && !next.customName) {
          next.customName = 'Monday - Wednesday';
        }
        // Regenerate or update slots for this specific schedule item when timing or price changes
        if (field === 'open' || field === 'close' || field === 'price') {
          const sPrice = parseFloat(field === 'price' ? val : next.price) || 0;
          const sOpen = field === 'open' ? val : next.open;
          const sClose = field === 'close' ? val : next.close;
          if (sOpen && sClose && sOpen !== sClose) {
            next.slots = generateSlotsFromRange(sOpen, sClose, sPrice);
          }
        }
        return next;
      }
      return t;
    });
    setFormData({ ...formData, timings: updated });
  };

  const handleAddTimingSchedule = () => {
    const nextId = Date.now();
    const newSchedule = {
      id: nextId,
      name: 'Monday - Wednesday',
      customName: '',
      open: '06:00 AM',
      close: '10:00 PM',
      price: '',
      slots: generateSlotsFromRange('06:00 AM', '10:00 PM', 0)
    };
    setFormData(prev => ({ ...prev, timings: [...(prev.timings || []), newSchedule] }));
  };

  const handleRemoveTimingSchedule = (id) => {
    setFormData(prev => {
      const filtered = (prev.timings || []).filter(t => t.id !== id);
      if (filtered.length === 0) {
        return {
          ...prev,
          timings: [
            { id: 1, name: 'Monday - Friday (Weekdays)', customName: '', open: '06:00 AM', close: '10:00 PM', price: '', slots: generateSlotsFromRange('06:00 AM', '10:00 PM', 0) }
          ]
        };
      }
      return { ...prev, timings: filtered };
    });
  };

  const handleScheduleSlotPriceUpdate = (scheduleId, slotLabel, newPrice) => {
    const pNum = parseFloat(newPrice) || 0;
    setFormData(prev => ({
      ...prev,
      timings: (prev.timings || []).map(t => {
        if (t.id === scheduleId) {
          const currentSlots = Array.isArray(t.slots) && t.slots.length > 0
            ? t.slots
            : generateSlotsFromRange(t.open || '06:00 AM', t.close || '10:00 PM', parseFloat(t.price) || 0);
          const updatedSlots = currentSlots.map(s => {
            if (s.label === slotLabel) {
              return { ...s, price: pNum };
            }
            return s;
          });
          return { ...t, slots: updatedSlots };
        }
        return t;
      })
    }));
  };

  const handleScheduleSlotToggleActive = (scheduleId, slotLabel) => {
    setFormData(prev => ({
      ...prev,
      timings: (prev.timings || []).map(t => {
        if (t.id === scheduleId) {
          const currentSlots = Array.isArray(t.slots) && t.slots.length > 0
            ? t.slots
            : generateSlotsFromRange(t.open || '06:00 AM', t.close || '10:00 PM', parseFloat(t.price) || 0);
          const updatedSlots = currentSlots.map(s => {
            if (s.label === slotLabel) {
              return { ...s, isActive: s.isActive === false ? true : false };
            }
            return s;
          });
          return { ...t, slots: updatedSlots };
        }
        return t;
      })
    }));
  };

  const handleScheduleSlotDelete = (scheduleId, slotLabel) => {
    setFormData(prev => ({
      ...prev,
      timings: (prev.timings || []).map(t => {
        if (t.id === scheduleId) {
          const currentSlots = Array.isArray(t.slots) && t.slots.length > 0
            ? t.slots
            : generateSlotsFromRange(t.open || '06:00 AM', t.close || '10:00 PM', parseFloat(t.price) || 0);
          const updatedSlots = currentSlots.filter(s => s.label !== slotLabel);
          return { ...t, slots: updatedSlots };
        }
        return t;
      })
    }));
  };

  const handleResetScheduleSlots = (scheduleId) => {
    setFormData(prev => ({
      ...prev,
      timings: (prev.timings || []).map(t => {
        if (t.id === scheduleId) {
          const schedPrice = parseFloat(t.price) || 0;
          return {
            ...t,
            slots: generateSlotsFromRange(t.open || '06:00 AM', t.close || '10:00 PM', schedPrice)
          };
        }
        return t;
      })
    }));
  };

  const priceVal = parseFloat(formData.price) || 0;
  const pType = feeSettings?.turf_partner_fee_type || 'percentage';
  const pVal = parseFloat(feeSettings?.turf_partner_fee_value ?? '5') || 0;

  let feeAmount = 0;
  let feeLabel = `Platform Fee (${pVal}%)`;

  if (pType === 'percentage') {
    feeAmount = Math.round(priceVal * (pVal / 100));
    feeLabel = `Platform Fee (${pVal}%)`;
  } else {
    feeAmount = Math.round(pVal);
    feeLabel = `Platform Fee (₹${pVal} Flat)`;
  }

  const netReceive = Math.max(0, Math.round(priceVal - feeAmount));

  return (
    <div className="main-form-grid" style={{ width: '100%' }}>
       <div style={{ gridColumn: '1 / -1', width: '100%' }}>
          <SectionHeader icon={<Clock size={20} />} title="Slots & Dynamic Pricing" subtitle="Set day ranges, custom slot timings, and different amounts per slot range" />
          
           <div style={{ marginBottom: '2rem', width: '100%' }}>
              {/* Official Notice Banner for Dynamic Pricing */}
              <div style={{
                background: 'linear-gradient(135deg, #F0FDF4 0%, #FFFFFF 100%)',
                border: '1.5px solid #86EFAC',
                borderRadius: '16px',
                padding: '1rem 1.25rem',
                marginBottom: '1.25rem',
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                boxShadow: '0 2px 10px rgba(22, 101, 52, 0.04)'
              }}>
                <div style={{
                  background: '#DCFCE7',
                  border: '1px solid #86EFAC',
                  borderRadius: '10px',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  fontSize: '1.1rem'
                }}>
                  💡
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: '0.86rem', fontWeight: '900', color: '#084734', letterSpacing: '-0.2px' }}>
                      Official Notice: Flexible & Peak-Hour Slot Pricing
                    </span>
                    <span style={{ fontSize: '0.68rem', fontWeight: '800', background: '#084734', color: '#CEF17B', padding: '2px 8px', borderRadius: '6px', textTransform: 'uppercase' }}>
                      Partner Guide
                    </span>
                  </div>
                  <p style={{ margin: 0, fontSize: '0.8rem', color: '#374151', lineHeight: '1.5', fontWeight: '600' }}>
                    You can configure different rates for different slot ranges (e.g. <strong>Morning hours</strong>, <strong>Evening prime-time</strong>, and <strong>Weekends</strong>) by clicking the <strong>"+ Add New Slot Range / Day Schedule"</strong> button below. Each schedule will automatically generate its slots and customers will be charged the exact rate for that specific time window.
                  </p>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <div>
                  <div style={{ fontSize: '0.95rem', fontWeight: '850', color: '#084734', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Calendar size={18} color="#084734" /> Operational Days & Schedule
                  </div>
                  <div style={{ fontSize: '0.75rem', color: '#64748B', fontWeight: '600' }}>
                    Set opening time, closing time, and custom amount for each day range
                  </div>
                </div>
                <button
                  type="button"
                  onClick={handleAddTimingSchedule}
                  style={{
                    background: '#F0FDF4', color: '#084734', border: '1.5px solid #DCEFB8',
                    padding: '6px 14px', borderRadius: '10px', fontSize: '0.78rem', fontWeight: '800',
                    cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px'
                  }}
                >
                  <Plus size={14} /> Add Day Schedule
                </button>
              </div>
             
             <div style={{ background: '#F8FAF7', padding: '1.5rem', borderRadius: '16px', border: '1.5px solid #EEF2E6', display: 'flex', flexDirection: 'column', gap: '1.25rem', width: '100%', boxSizing: 'border-box' }}>
                {(formData.timings || []).map((item) => (
                  <div key={item.id} style={{ background: '#fff', padding: '1.2rem', borderRadius: '14px', border: '1.5px solid #E9EDE8', display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%', boxSizing: 'border-box', boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, minWidth: '220px', flexWrap: 'wrap' }}>
                        <select
                          value={item.name}
                          onChange={(e) => handleTimingChange(item, 'name', e.target.value)}
                          style={{
                            padding: '7px 12px', borderRadius: '8px', border: '1.5px solid #DCEFB8',
                            fontSize: '0.85rem', fontWeight: '800', color: '#084734', outline: 'none', background: '#F8FAF7'
                          }}
                        >
                          {DAY_RANGE_OPTIONS.map(opt => (
                            <option key={opt.id} value={opt.label}>{opt.label}</option>
                          ))}
                        </select>

                        {item.name === 'Custom Days Range...' && (
                          <input
                            type="text"
                            placeholder="e.g. Monday - Wednesday"
                            value={item.customName || ''}
                            onChange={(e) => handleTimingChange(item, 'customName', e.target.value)}
                            style={{
                              padding: '6px 12px', borderRadius: '8px', border: '1.5px solid #DCEFB8',
                              fontSize: '0.85rem', fontWeight: '700', color: '#161616', outline: 'none', minWidth: '180px'
                            }}
                          />
                        )}
                      </div>
                      
                      <button
                        type="button"
                        onClick={() => handleRemoveTimingSchedule(item.id)}
                        style={{
                          background: '#FEE2E2', border: '1px solid #FCA5A5', color: '#B91C1C',
                          padding: '4px 10px', borderRadius: '8px', fontSize: '0.74rem', fontWeight: '800',
                          cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px'
                        }}
                        title="Delete day schedule"
                      >
                        <Trash2 size={13} /> Delete
                      </button>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '12px', alignItems: 'start' }}>
                       <div>
                         <label style={{ fontSize: '0.72rem', fontWeight: '800', color: '#374151', display: 'block', marginBottom: '4px' }}>Opening Time (12h)</label>
                         <TimePicker12
                           value={item.open}
                           onChange={(val) => handleTimingChange(item, 'open', val)}
                         />
                       </div>
                       <div>
                         <label style={{ fontSize: '0.72rem', fontWeight: '800', color: '#374151', display: 'block', marginBottom: '4px' }}>Closing Time (12h)</label>
                         <TimePicker12
                           value={item.close}
                           onChange={(val) => handleTimingChange(item, 'close', val)}
                         />
                       </div>
                       <div>
                         <label style={{ fontSize: '0.72rem', fontWeight: '800', color: '#374151', display: 'block', marginBottom: '4px' }}>Amount for this Day Range (₹/hr)</label>
                         <div style={{ position: 'relative', marginTop: '2px' }}>
                           <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', fontWeight: '800', color: '#084734', fontSize: '0.9rem' }}>₹</span>
                           <input
                             type="number"
                             min="0"
                             placeholder={formData.price ? `Default: ${formData.price}` : "e.g. 1000"}
                             value={item.price ?? ''}
                             onChange={(e) => handleTimingChange(item, 'price', e.target.value.replace(/[^0-9]/g, ''))}
                             style={{
                               width: '100%',
                               padding: '9px 12px 9px 28px',
                               borderRadius: '10px',
                               border: '1.5px solid #DCEFB8',
                               outline: 'none',
                               fontSize: '0.9rem',
                               fontWeight: '800',
                               color: '#084734',
                               background: '#F8FAF7',
                               boxSizing: 'border-box'
                             }}
                           />
                         </div>
                       </div>
                    </div>
                  </div>
                ))}

                {/* + Add New Slot Range / Day Schedule Button */}
                <button
                  type="button"
                  onClick={handleAddTimingSchedule}
                  style={{
                    background: '#F0FDF4',
                    border: '2px dashed #084734',
                    color: '#084734',
                    padding: '12px 18px',
                    borderRadius: '14px',
                    fontWeight: '850',
                    fontSize: '0.88rem',
                    cursor: 'pointer',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    transition: 'all 0.2s',
                    boxSizing: 'border-box'
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = '#DCEFB8'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = '#F0FDF4'; }}
                >
                  <Plus size={18} color="#084734" /> Add New Slot Range / Day Schedule
                </button>
             </div>

              {/* DYNAMIC SLOT CARDS FOR EVERY CONFIGURED SCHEDULE RANGE */}
              {(formData.timings || []).map((schedule, schedIdx) => {
                const isWeekend = schedule.name?.includes('Weekend') || schedule.name?.includes('Saturday') || schedule.name?.includes('Sunday');
                const isCustom = schedule.name === 'Custom Days Range...' || (!schedule.name?.includes('Weekday') && !schedule.name?.includes('Weekend'));
                const displayName = schedule.name === 'Custom Days Range...' && schedule.customName ? schedule.customName : schedule.name;
                const schedPrice = parseFloat(schedule.price) || 0;
                
                const slotsList = Array.isArray(schedule.slots) && schedule.slots.length > 0
                  ? schedule.slots
                  : generateSlotsFromRange(schedule.open || '06:00 AM', schedule.close || '10:00 PM', schedPrice);

                const cardBorder = isWeekend ? '#FCD34D' : isCustom ? '#86EFAC' : '#DCEFB8';
                const cardBg = isWeekend 
                  ? 'linear-gradient(135deg, #FFFFFF 0%, #FFFDF5 100%)' 
                  : isCustom 
                  ? 'linear-gradient(135deg, #FFFFFF 0%, #F0FDF4 100%)'
                  : 'linear-gradient(135deg, #FFFFFF 0%, #F8FAF7 100%)';
                const icon = isWeekend ? '🎉' : isCustom ? '⚡' : '📅';
                const badgeColor = isWeekend ? '#92400E' : isCustom ? '#166534' : '#084734';
                const badgeBg = isWeekend ? '#FEF3C7' : isCustom ? '#DCFCE7' : '#DCEFB8';
                const badgeBorder = isWeekend ? '#FDE68A' : isCustom ? '#86EFAC' : '#CEF17B';

                return (
                  <div key={schedule.id || schedIdx} style={{
                    marginTop: '1.5rem',
                    width: '100%',
                    boxSizing: 'border-box',
                    background: cardBg,
                    padding: '1.5rem 1.75rem',
                    borderRadius: '20px',
                    border: `1.5px solid ${cardBorder}`,
                    boxShadow: '0 10px 30px rgba(8, 71, 52, 0.04)'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', flexWrap: 'wrap', gap: '8px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontSize: '1.25rem' }}>{icon}</span>
                        <div>
                          <h5 style={{ margin: 0, fontSize: '1.02rem', fontWeight: '850', color: badgeColor }}>
                            {displayName}
                          </h5>
                          <div style={{ fontSize: '0.75rem', color: '#64748B', fontWeight: '700', marginTop: '2px' }}>
                            ⏰ {schedule.open || '06:00 AM'} - {schedule.close || '10:00 PM'} • Rate: <span style={{ color: badgeColor, fontWeight: '850' }}>₹{schedPrice}/hr</span>
                          </div>
                        </div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <button
                          type="button"
                          onClick={() => handleResetScheduleSlots(schedule.id)}
                          style={{ background: '#fff', border: `1.5px solid ${cardBorder}`, color: badgeColor, padding: '4px 10px', borderRadius: '8px', fontSize: '0.72rem', fontWeight: '800', cursor: 'pointer' }}
                          title="Reset slots to schedule rate"
                        >
                          ↺ Reset Clean Slots
                        </button>
                        <span style={{ fontSize: '0.78rem', fontWeight: '850', background: badgeBg, color: badgeColor, padding: '4px 12px', borderRadius: '20px', border: `1px solid ${badgeBorder}` }}>
                          {slotsList.length} Slots
                        </span>
                      </div>
                    </div>

                    {slotsList.length === 0 ? (
                      <div style={{ padding: '1.25rem', background: '#F8FAF7', borderRadius: '14px', border: '1.5px dashed #CEF17B', textAlign: 'center', color: '#084734', fontSize: '0.85rem', fontWeight: '700' }}>
                        ⚡ Set operational 'From' and 'To' timings in schedule above to generate slots.
                      </div>
                    ) : (
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(210px, 1fr))', gap: '10px', width: '100%' }}>
                        {slotsList.map((slotItem, sIdx) => {
                          const norm = normalizeSlot(slotItem);
                          const isActive = norm.isActive;
                          const slotPrice = norm.price !== undefined ? norm.price : schedPrice;
                          const isEditing = editingSlotPriceKey === `sched-${schedule.id}-${norm.label}`;

                          return (
                            <div key={sIdx} style={{
                              display: 'flex', flexDirection: 'column', gap: '6px',
                              background: isActive ? '#FFFFFF' : '#F1F5F9',
                              border: isActive ? `1.5px solid ${cardBorder}` : '1.5px dashed #94A3B8',
                              color: isActive ? '#084734' : '#64748B',
                              padding: '10px 12px', borderRadius: '14px', fontSize: '0.82rem', fontWeight: '800',
                              boxShadow: isActive ? '0 2px 6px rgba(8, 71, 52, 0.04)' : 'none',
                              transition: 'all 0.2s'
                            }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                  <span>{norm.label}</span>
                                  {!isActive && (
                                    <span style={{ fontSize: '0.75rem' }} title="Freezed">
                                      ❄️
                                    </span>
                                  )}
                                </div>
                                <button
                                  type="button"
                                  onClick={() => handleScheduleSlotDelete(schedule.id, norm.label)}
                                  style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', padding: '2px' }}
                                  title="Delete slot"
                                >
                                  <Trash2 size={13} />
                                </button>
                              </div>

                              {/* Price Tag & Quick Inline Edit */}
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '2px', borderTop: '1px dashed #E2E8F0', paddingTop: '6px' }}>
                                {isEditing ? (
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <span style={{ fontSize: '0.75rem', fontWeight: '800', color: '#084734' }}>₹</span>
                                    <input
                                      type="number"
                                      autoFocus
                                      value={inlinePriceVal}
                                      onChange={e => setInlinePriceVal(e.target.value)}
                                      style={{ width: '60px', padding: '2px 4px', fontSize: '0.8rem', fontWeight: '800', borderRadius: '6px', border: '1.5px solid #084734', outline: 'none' }}
                                    />
                                    <button
                                      type="button"
                                      onClick={() => {
                                        handleScheduleSlotPriceUpdate(schedule.id, norm.label, inlinePriceVal);
                                        setEditingSlotPriceKey(null);
                                      }}
                                      style={{ background: '#084734', color: '#CEF17B', border: 'none', borderRadius: '4px', padding: '2px 6px', fontSize: '0.72rem', fontWeight: '800', cursor: 'pointer' }}
                                    >
                                      ✓
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => setEditingSlotPriceKey(null)}
                                      style={{ background: '#E2E8F0', color: '#334155', border: 'none', borderRadius: '4px', padding: '2px 6px', fontSize: '0.72rem', fontWeight: '800', cursor: 'pointer' }}
                                    >
                                      ✕
                                    </button>
                                  </div>
                                ) : (
                                  <div
                                    onClick={() => {
                                      setEditingSlotPriceKey(`sched-${schedule.id}-${norm.label}`);
                                      setInlinePriceVal(slotPrice);
                                    }}
                                    style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer', background: '#F0FDF4', padding: '2px 8px', borderRadius: '6px', border: '1px solid #DCEFB8' }}
                                    title="Click to edit slot amount"
                                  >
                                    <span style={{ fontSize: '0.78rem', fontWeight: '900', color: '#084734' }}>₹{slotPrice}</span>
                                    <Edit2 size={11} color="#084734" />
                                  </div>
                                )}

                                <button
                                  type="button"
                                  onClick={() => handleScheduleSlotToggleActive(schedule.id, norm.label)}
                                  title={isActive ? "Freeze slot" : "Activate slot"}
                                  style={{
                                    background: isActive ? '#FEF3C7' : '#D1FAE5',
                                    color: isActive ? '#92400E' : '#065F46',
                                    border: 'none', borderRadius: '6px', padding: '3px 8px',
                                    fontSize: '0.72rem', fontWeight: '800', cursor: 'pointer',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                                  }}
                                >
                                  {isActive ? '⏸️ Active' : '▶️ Freezed'}
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}


          </div>

          <div style={{ background: '#fff9eb', border: '1.5px solid #fef3c7', padding: '1.5rem', borderRadius: '16px', display: 'flex', gap: '15px', alignItems: 'center' }}>
             <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#fef3c7', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#d97706' }}>
                <Info size={20} />
             </div>
             <p style={{ fontSize: '0.85rem', color: '#92400e', fontWeight: '600', margin: 0 }}>
               💡 You can define custom prices for individual slots, or apply range pricing (e.g. 6:00 AM - 6:00 PM @ ₹800, 6:00 PM - 12:00 AM @ ₹1200).
             </p>
          </div>
       </div>

       <div style={{ gridColumn: '1 / -1', width: '100%', marginTop: '1rem' }}>
          <div style={{ background: 'white', borderRadius: '24px', border: '1.5px solid #EEF2E6', padding: '1.75rem', width: '100%', boxSizing: 'border-box' }}>
             <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1.25rem' }}>
               <Zap size={18} color="#084734" />
               <h4 style={{ fontSize: '1.05rem', fontWeight: '850', color: '#084734', margin: 0 }}>Pricing & Earnings Preview</h4>
             </div>

              {/* Day Schedule & Slot Range Rates Breakdown - 2 Cards per Row */}
              <div style={{ marginBottom: '1.5rem', width: '100%' }}>
                <div style={{ fontSize: '0.8rem', fontWeight: '800', color: '#084734', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px' }}>
                  📅 Schedule & Range Rates ({ (formData.timings || []).length })
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '14px', width: '100%' }}>
                  {(formData.timings || []).map((t) => {
                    const isWeekend = t.name?.includes('Weekend') || t.name?.includes('Saturday') || t.name?.includes('Sunday');
                    const isCustom = t.name === 'Custom Days Range...' || (!t.name?.includes('Weekday') && !t.name?.includes('Weekend'));
                    const displayName = t.name === 'Custom Days Range...' && t.customName ? t.customName : t.name;
                    const rangePrice = parseFloat(t.price || formData.price) || 0;
                    let rangeFee = 0;
                    if (pType === 'percentage') {
                      rangeFee = Math.round(rangePrice * (pVal / 100));
                    } else {
                      rangeFee = Math.round(pVal);
                    }
                    const rangeNet = Math.max(0, Math.round(rangePrice - rangeFee));
                    const itemFeeLabel = pType === 'percentage' ? `Platform Fee (${pVal}%)` : `Platform Fee (₹${pVal} Flat)`;

                    const cardBg = isWeekend ? 'linear-gradient(135deg, #FFFFFF 0%, #FFFDF5 100%)' : isCustom ? 'linear-gradient(135deg, #FFFFFF 0%, #F0FDF4 100%)' : 'linear-gradient(135deg, #FFFFFF 0%, #F8FAF7 100%)';
                    const cardBorder = isWeekend ? '#FCD34D' : isCustom ? '#86EFAC' : '#DCEFB8';
                    const titleColor = isWeekend ? '#92400E' : isCustom ? '#166534' : '#084734';
                    const badgeBg = isWeekend ? '#FEF3C7' : isCustom ? '#DCFCE7' : '#DCEFB8';
                    const badgeBorder = isWeekend ? '#FDE68A' : isCustom ? '#86EFAC' : '#CEF17B';

                    return (
                      <div key={t.id} style={{
                        background: cardBg,
                        borderRadius: '16px',
                        border: `1.5px solid ${cardBorder}`,
                        padding: '16px',
                        boxShadow: '0 4px 14px rgba(8, 71, 52, 0.04)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                      }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', flexWrap: 'wrap', gap: '6px' }}>
                          <span style={{ fontSize: '0.88rem', fontWeight: '850', color: titleColor }}>{displayName}</span>
                          <span style={{ fontSize: '0.72rem', background: badgeBg, color: titleColor, border: `1px solid ${badgeBorder}`, padding: '3px 9px', borderRadius: '8px', fontWeight: '800' }}>
                            ⏰ {t.open} - {t.close}
                          </span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '6px', borderBottom: '1px dashed #E2E8F0', fontSize: '0.82rem' }}>
                            <span style={{ color: '#4B5563', fontWeight: '600' }}>Rate / Hour</span>
                            <span style={{ fontWeight: '850', color: '#161616', fontSize: '0.9rem' }}>₹ {rangePrice}</span>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '6px', borderBottom: '1px dashed #E2E8F0', fontSize: '0.82rem' }}>
                            <span style={{ color: '#4B5563', fontWeight: '600' }}>{itemFeeLabel}</span>
                            <span style={{ fontWeight: '750', color: '#DC2626' }}>- ₹ {rangePrice ? rangeFee : 0}</span>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: isWeekend ? '#FEF3C7' : '#DCEFB8', padding: '9px 12px', borderRadius: '10px', border: `1px solid ${isWeekend ? '#FDE68A' : '#CEF17B'}` }}>
                            <span style={{ fontSize: '0.82rem', fontWeight: '800', color: titleColor }}>You Receive (Net)</span>
                            <span style={{ fontSize: '1rem', fontWeight: '900', color: titleColor }}>₹ {rangePrice ? rangeNet : 0}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Overridden Individual Slot Rates Breakdown - 2 Cards per Row */}
              {(() => {
                const baseNum = parseFloat(formData.price) || 0;
                const customOverrides = [];
                (formData.timings || []).forEach(timing => {
                  const schedPrice = parseFloat(timing.price || formData.price) || 0;
                  const slots = Array.isArray(timing.slots) ? timing.slots : [];
                  const timingLabel = timing.name === 'Custom Days Range...' && timing.customName ? timing.customName : timing.name;
                  
                  slots.forEach(s => {
                    const norm = normalizeSlot(s);
                    if (norm.isActive && norm.price !== undefined && norm.price !== null && norm.price !== '' && parseFloat(norm.price) !== schedPrice) {
                      customOverrides.push({
                        ...norm,
                        scheduleId: timing.id,
                        timingLabel
                      });
                    }
                  });
                });

                const totalCustom = customOverrides.length;

                return (
                  <div style={{ marginBottom: '1.25rem', width: '100%' }}>
                    <div style={{ fontSize: '0.8rem', fontWeight: '800', color: '#084734', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px' }}>
                      🏷️ Custom Slot Overrides ({totalCustom})
                    </div>

                    {totalCustom === 0 ? (
                      <div style={{ background: '#F0FDF4', border: '1px dashed #BBF7D0', borderRadius: '12px', padding: '12px', textAlign: 'center', fontSize: '0.78rem', fontWeight: '700', color: '#15803D' }}>
                        ✓ All individual slots currently follow their respective Day Schedule rates.
                      </div>
                    ) : (
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '12px', width: '100%' }}>
                        {customOverrides.map((s, idx) => {
                          const sp = parseFloat(s.price) || 0;
                          const sFee = pType === 'percentage' ? Math.round(sp * (pVal / 100)) : Math.round(pVal);
                          const sNet = Math.max(0, Math.round(sp - sFee));
                          const itemFeeLabel = pType === 'percentage' ? `Platform Fee (${pVal}%)` : `Platform Fee (₹${pVal} Flat)`;

                          return (
                            <div key={`c-ov-${idx}`} style={{
                              background: '#FFFFFF',
                              borderRadius: '14px',
                              border: '1.5px solid #86EFAC',
                              padding: '14px',
                              boxShadow: '0 2px 8px rgba(22, 101, 52, 0.04)',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between'
                            }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                <span style={{ fontSize: '0.82rem', fontWeight: '800', color: '#166534' }}>[{s.timingLabel}]</span>
                                <span style={{ fontSize: '0.72rem', background: '#DCFCE7', color: '#166534', border: '1px solid #86EFAC', padding: '2px 8px', borderRadius: '6px', fontWeight: '800' }}>
                                  {s.label}
                                </span>
                              </div>
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '4px', borderBottom: '1px dashed #E2E8F0', fontSize: '0.8rem' }}>
                                  <span style={{ color: '#4B5563', fontWeight: '600' }}>Slot Rate</span>
                                  <span style={{ fontWeight: '850', color: '#161616' }}>₹ {sp}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '4px', borderBottom: '1px dashed #E2E8F0', fontSize: '0.8rem' }}>
                                  <span style={{ color: '#4B5563', fontWeight: '600' }}>{itemFeeLabel}</span>
                                  <span style={{ fontWeight: '750', color: '#DC2626' }}>- ₹ {sp ? sFee : 0}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#DCFCE7', padding: '8px 10px', borderRadius: '8px', border: '1px solid #86EFAC' }}>
                                  <span style={{ fontSize: '0.8rem', fontWeight: '800', color: '#166534' }}>You Receive (Net)</span>
                                  <span style={{ fontSize: '0.92rem', fontWeight: '900', color: '#166534' }}>₹ {sp ? sNet : 0}</span>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })()}

             <p style={{ fontSize: '0.74rem', color: '#64748B', marginTop: '1rem', textAlign: 'center', fontWeight: '600', lineHeight: '1.4', margin: '0' }}>
               💡 Platform fee is calculated dynamically based on official TurfX admin settings. Net earnings are transferred directly to your wallet upon booking completion.
             </p>
          </div>
       </div>
    </div>
  );
}

function AmenitiesSection({ formData, setFormData }) {
  const popular = [
    { id: 'floodlights', label: 'Floodlights', icon: <Clock size={20} /> },
    { id: 'changing', label: 'Changing Rooms', icon: <UserIcon size={20} /> },
    { id: 'parking', label: 'Parking', icon: <MapPin size={20} /> },
    { id: 'water', label: 'Drinking Water', icon: <Info size={20} /> },
    { id: 'seating', label: 'Seating Area', icon: <Users size={20} /> },
    { id: 'washrooms', label: 'Washrooms', icon: <ShieldCheck size={20} /> },
    { id: 'firstaid', label: 'First Aid', icon: <ShieldCheck size={20} /> },
    { id: 'cafeteria', label: 'Cafeteria', icon: <Coffee size={20} /> },
    { id: 'wifi', label: 'Wi-Fi', icon: <Wifi size={20} /> },
    { id: 'music', label: 'Music System', icon: <Music size={20} /> },
    { id: 'ac', label: 'AC Pavilion', icon: <Wind size={20} /> },
  ];

  const toggleAmenity = (id) => {
    const amenities = formData.amenities.includes(id) 
      ? formData.amenities.filter(a => a !== id)
      : [...formData.amenities, id];
    setFormData({ ...formData, amenities });
  };

  return (
    <div className="main-form-grid">
       <div>
          <SectionHeader icon={<ShieldCheck size={20} />} title="Amenities" subtitle="Select the amenities available at your venue" />
          
          <div style={{ fontSize: '0.8rem', fontWeight: '800', color: '#161616', marginBottom: '1.5rem', textTransform: 'uppercase' }}>Popular Amenities</div>
          <div className="amenities-grid">
             {popular.map(a => (
               <div 
                 key={a.id} 
                 onClick={() => toggleAmenity(a.id)}
                 style={{ 
                   padding: '1.5rem 10px', borderRadius: '16px', border: '1.5px solid',
                   borderColor: formData.amenities.includes(a.id) ? '#CEF17B' : '#DCEFB8',
                   background: formData.amenities.includes(a.id) ? '#DCEFB8' : 'white',
                   cursor: 'pointer', textAlign: 'center', transition: '0.2s',
                   position: 'relative'
                 }}
               >
                 <div style={{ color: formData.amenities.includes(a.id) ? '#084734' : '#374151', marginBottom: '10px', display: 'flex', justifyContent: 'center' }}>{a.icon}</div>
                 <div style={{ fontSize: '0.75rem', fontWeight: '800', color: formData.amenities.includes(a.id) ? '#084734' : '#374151' }}>{a.label}</div>
                 <div style={{ position: 'absolute', top: '10px', right: '10px', width: '16px', height: '16px', borderRadius: '4px', border: '1.5px solid #DCEFB8', background: formData.amenities.includes(a.id) ? '#084734' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {formData.amenities.includes(a.id) && <Check size={12} color="white" strokeWidth={4} />}
                 </div>
               </div>
             ))}
          </div>

          <Field label="Additional Amenities (Optional)">
             <div style={{ display: 'flex', gap: '12px' }}>
                <input
                  type="text"
                  placeholder="Enter amenity and press Add"
                  value={formData.customAmenity || ''}
                  onChange={(e) => setFormData({ ...formData, customAmenity: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && formData.customAmenity?.trim()) {
                      const val = formData.customAmenity.trim();
                      if (!formData.amenities.includes(val)) {
                        setFormData({ ...formData, amenities: [...formData.amenities, val], customAmenity: '' });
                      }
                    }
                  }}
                  style={inputStyle}
                />
                <button
                  onClick={() => {
                    const val = (formData.customAmenity || '').trim();
                    if (!val) return;
                    if (!formData.amenities.includes(val)) {
                      setFormData({ ...formData, amenities: [...formData.amenities, val], customAmenity: '' });
                    } else {
                      setFormData({ ...formData, customAmenity: '' });
                    }
                  }}
                  style={{ padding: '0 25px', borderRadius: '12px', border: 'none', background: '#CEF17B', color: '#084734', fontWeight: '800', cursor: 'pointer', whiteSpace: 'nowrap' }}
                >
                  + Add
                </button>
             </div>
             {/* Show added custom amenities as removable chips */}
             {formData.amenities.filter(a => !['floodlights','changing','parking','water','seating','washrooms','firstaid','cafeteria','wifi','music','ac'].includes(a)).length > 0 && (
               <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '12px' }}>
                 {formData.amenities
                   .filter(a => !['floodlights','changing','parking','water','seating','washrooms','firstaid','cafeteria','wifi','music','ac'].includes(a))
                   .map((a, i) => (
                     <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#DCEFB8', borderRadius: '8px', padding: '6px 12px', fontSize: '0.82rem', fontWeight: '700', color: '#084734' }}>
                       {a}
                       <button
                         onClick={() => setFormData({ ...formData, amenities: formData.amenities.filter(x => x !== a) })}
                         style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#084734', display: 'flex', alignItems: 'center', padding: 0, marginLeft: '2px' }}
                       >
                         <Trash2 size={13} />
                       </button>
                     </div>
                   ))
                 }
               </div>
             )}
          </Field>
       </div>

       <div>
          <div style={{ background: 'white', borderRadius: '24px', border: '1.5px solid #EEF2E6', padding: '2rem', marginBottom: '2rem' }}>
             <h4 style={{ fontSize: '1rem', fontWeight: '800', marginBottom: '1.5rem' }}>Amenities Preview</h4>
             <div className="grid-2-col">
                {formData.amenities.length > 0 ? formData.amenities.map(id => (
                  <div key={id} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#084734', fontSize: '0.85rem', fontWeight: '700' }}>
                     <Check size={16} /> {popular.find(p => p.id === id)?.label || id}
                  </div>
                )) : <div style={{ color: '#374151', fontSize: '0.85rem', fontStyle: 'italic' }}>No amenities selected</div>}
             </div>
          </div>

          <div style={{ background: 'white', borderRadius: '24px', border: '1.5px solid #EEF2E6', padding: '2rem' }}>
             <h4 style={{ fontSize: '1rem', fontWeight: '800', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
               <Star size={18} color="#084734" /> Why Amenities Matter?
             </h4>
             <ul style={{ padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <li style={whyItemStyle}><Check size={16} color="#084734" /> Helps players identify venues that meet their requirments.</li>
                <li style={whyItemStyle}><Check size={16} color="#084734" /> Strengthens customer trust and improves the venue's brand image.</li>
                <li style={whyItemStyle}><Check size={16} color="#084734" /> Adds value to the venue and justifies higher pricing.</li>
             </ul>
          </div>
       </div>
    </div>
  );
}

function PhotosUpload({ formData, setFormData, token }) {
  const [uploading, setUploading] = useState(false);
  
  // Compress image before converting to base64
  const compressImage = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;
          
          // Resize if image is too large (max 1200px width)
          const maxWidth = 1200;
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
          
          canvas.width = width;
          canvas.height = height;
          
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          
          // Convert to base64 with compression (0.7 quality)
          const compressedBase64 = canvas.toDataURL('image/jpeg', 0.7);
          
          resolve({
            url: compressedBase64,
            name: file.name,
            type: 'image',
            size: Math.round(compressedBase64.length * 0.75) // Approximate size
          });
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };
  
  const handleFileUpload = async (e, type = 'image') => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    
    // Limit to 5 images max
    if (type === 'image' && (formData.images || []).length + files.length > 5) {
      alert('Maximum 5 images allowed. Please remove some images first.');
      return;
    }
    
    setUploading(true);
    
    try {
      const uploadFormData = new FormData();
      
      if (type === 'image') {
        // Compress images first
        const compressed = await Promise.all(files.map(file => compressImage(file)));
        compressed.forEach(img => {
          const fileObj = dataURLtoFile(img.url, img.name);
          uploadFormData.append('images', fileObj);
        });
      } else {
        // Videos are uploaded directly as files
        files.forEach(file => {
          if (file.size > 50 * 1024 * 1024) {
            alert(`Video "${file.name}" exceeds the maximum limit of 50MB.`);
            throw new Error('Video too large');
          }
          uploadFormData.append('images', file); // Backend expects "images" field name
        });
      }

      // Upload to backend
      const response = await axios.post(`${API}/upload/images`, uploadFormData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      const uploadedFiles = response.data.urls.map(u => ({
        url: u.url, // absolute URL returned by backend
        name: u.filename,
        type: type
      }));
      
      if (type === 'image') {
        setFormData({
          ...formData,
          images: [...(formData.images || []), ...uploadedFiles]
        });
      } else {
        setFormData({
          ...formData,
          videos: [...(formData.videos || []), ...uploadedFiles]
        });
      }
    } catch (error) {
      console.error('Upload error:', error);
      if (error.response?.status === 413) {
        alert('File upload failed: Request Entity Too Large (413). Please make sure Nginx configuration on server has been updated to allow larger uploads.');
      } else {
        alert(error.message || 'Failed to upload files. Please try again.');
      }
    }
    
    setUploading(false);
  };
  
  const removeFile = (index, type = 'image') => {
    if (type === 'image') {
      const newImages = formData.images.filter((_, i) => i !== index);
      setFormData({ ...formData, images: newImages });
    } else {
      const newVideos = formData.videos.filter((_, i) => i !== index);
      setFormData({ ...formData, videos: newVideos });
    }
  };
  
  return (
    <div>
       <SectionHeader icon={<Upload size={20} />} title="Photos & Videos" subtitle="Upload high quality photos and videos to showcase your venue" />
       
       {/* PHOTOS SECTION */}
       <div style={{ marginBottom: '3rem' }}>
         <h4 style={{ fontSize: '1rem', fontWeight: '800', marginBottom: '1.5rem', color: '#161616' }}>Photos</h4>
         <div className="photos-grid">
            {/* Upload Button */}
            <label style={{ 
              aspectRatio: '1', borderRadius: '24px', border: '2.5px dashed #DCEFB8', background: '#F8FAF7',
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '15px',
              cursor: 'pointer', transition: '0.2s', padding: '2rem'
            }}>
               <input 
                 type="file" 
                 accept="image/*" 
                 multiple 
                 onChange={(e) => handleFileUpload(e, 'image')}
                 style={{ display: 'none' }}
               />
               <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#084734', boxShadow: '0 8px 20px rgba(0,0,0,0.06)' }}>
                  <Upload size={24} />
               </div>
               <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '0.9rem', fontWeight: '800', color: '#084734' }}>
                     {uploading ? 'Uploading...' : 'Click to upload'}
                  </div>
                  <div style={{ fontSize: '0.75rem', fontWeight: '600', color: '#374151', marginTop: '6px' }}>JPG, PNG up to 5MB</div>
               </div>
            </label>
            
            {/* Uploaded Images */}
            {(formData.images || []).map((img, i) => (
              <div key={i} style={{ aspectRatio: '1', borderRadius: '24px', overflow: 'hidden', border: '1.5px solid #EEF2E6', position: 'relative' }}>
                 <img src={img.url} alt={`Venue ${i+1}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                 <div 
                   onClick={() => removeFile(i, 'image')}
                   style={{ position: 'absolute', top: '12px', right: '12px', background: 'rgba(239,68,68,0.9)', color: 'white', padding: '8px', borderRadius: '10px', cursor: 'pointer' }}
                 >
                    <Trash2 size={16} />
                 </div>
              </div>
            ))}
         </div>
       </div>
       
       {/* VIDEOS SECTION */}
       <div style={{ marginBottom: '2.5rem' }}>
         <h4 style={{ fontSize: '1rem', fontWeight: '800', marginBottom: '1.5rem', color: '#161616' }}>Videos (Optional)</h4>
         <div className="videos-grid">
            {/* Upload Button */}
            <label style={{ 
              aspectRatio: '16/9', borderRadius: '24px', border: '2.5px dashed #DCEFB8', background: '#F8FAF7',
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '15px',
              cursor: 'pointer', transition: '0.2s', padding: '2rem'
            }}>
               <input 
                 type="file" 
                 accept="video/*" 
                 multiple 
                 onChange={(e) => handleFileUpload(e, 'video')}
                 style={{ display: 'none' }}
               />
               <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#3b82f6', boxShadow: '0 8px 20px rgba(0,0,0,0.06)' }}>
                  <Upload size={24} />
               </div>
               <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '0.9rem', fontWeight: '800', color: '#3b82f6' }}>
                     {uploading ? 'Uploading...' : 'Upload Video'}
                  </div>
                  <div style={{ fontSize: '0.75rem', fontWeight: '600', color: '#374151', marginTop: '6px' }}>MP4, MOV up to 50MB</div>
               </div>
            </label>
            
            {/* Uploaded Videos */}
            {(formData.videos || []).map((video, i) => (
              <div key={i} style={{ aspectRatio: '16/9', borderRadius: '24px', overflow: 'hidden', border: '1.5px solid #EEF2E6', position: 'relative', background: '#000' }}>
                 <video 
                   src={video.url} 
                   style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                   muted
                   loop
                   onMouseEnter={(e) => e.target.play()}
                   onMouseLeave={(e) => e.target.pause()}
                 />
                 <div 
                   onClick={() => removeFile(i, 'video')}
                   style={{ position: 'absolute', top: '12px', right: '12px', background: 'rgba(239,68,68,0.9)', color: 'white', padding: '8px', borderRadius: '10px', cursor: 'pointer', zIndex: 10 }}
                 >
                    <Trash2 size={16} />
                 </div>
              </div>
            ))}
         </div>
       </div>

       <div style={{ background: '#F8FAF7', padding: '2rem', borderRadius: '24px', border: '1.5px solid #EEF2E6' }}>
          <h4 style={{ fontWeight: '800', fontSize: '1rem', marginBottom: '1rem', color: '#161616' }}>Upload Guidelines</h4>
          <div className="guidelines-grid">
             <GuideItem text="Use original or licensed images" />
             <GuideItem text="Use proper image size and aspect ratio(16:9)" />
             <GuideItem text="Optimize images for fast loading" />
             <GuideItem text="Avoid watermarks and copyrighted images" />
             <GuideItem text="Use high-quality, clear images" />
             <GuideItem text="Ensure images are mobile-friendly and responsive" />
          </div>
       </div>
    </div>
  );
}

function GuideItem({ text }) {
  return (
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', color: '#374151', fontSize: '0.85rem', fontWeight: '600' }}>
       <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#084734' }}></div> {text}
    </div>
  );
}

function ReviewSubmit({ formData, weekdaySlots = [], weekendSlots = [], onEdit }) {
  const popular = {
    floodlights: 'Floodlights', changing: 'Changing Rooms', parking: 'Parking',
    water: 'Drinking Water', seating: 'Seating Area', washrooms: 'Washrooms',
    firstaid: 'First Aid', cafeteria: 'Cafeteria', wifi: 'Wi-Fi', music: 'Music System', ac: 'AC Pavilion'
  };

  const getSlotsForTiming = (timing, idx) => {
    if (timing.slots && Array.isArray(timing.slots) && timing.slots.length > 0) {
      return timing.slots;
    }
    const tName = (timing.name || '').toLowerCase();
    if (tName.includes('weekend') || tName.includes('saturday') || tName.includes('sunday')) {
      return weekendSlots;
    }
    if (tName.includes('weekday') || tName.includes('monday') || tName.includes('friday')) {
      return weekdaySlots;
    }
    return idx === 1 ? weekendSlots : weekdaySlots;
  };

  return (
    <div style={{ animation: 'fadeIn 0.5s ease-out' }}>
       <SectionHeader icon={<ShieldCheck size={20} />} title="Review & Submit" subtitle="Please check all the details before final submission" />
       
       <div className="review-grid">
          <ReviewCard title="Basic Details" step={1} onEdit={onEdit}>
             <InfoItem label="Venue Name" value={formData.name} />
             <InfoItem label="Sports" value={formData.sports.join(', ')} />
             <InfoItem label="Location" value={`${formData.location}, ${formData.city}, ${formData.state} - ${formData.pincode || ''}`} />
          </ReviewCard>

          <ReviewCard title="Pricing & Info" step={3} onEdit={onEdit}>
             {(() => {
               const schedPrices = (formData.timings || [])
                 .map(t => parseFloat(t.price))
                 .filter(p => !isNaN(p) && p > 0);
               if (formData.price && parseFloat(formData.price) > 0) {
                 schedPrices.push(parseFloat(formData.price));
               }
               const minP = schedPrices.length > 0 ? Math.min(...schedPrices) : 0;
               const maxP = schedPrices.length > 0 ? Math.max(...schedPrices) : 0;
               const priceText = minP > 0 ? (minP === maxP ? `₹ ${minP}/hr` : `₹ ${minP} - ₹ ${maxP}/hr`) : (formData.price ? `₹ ${formData.price}/hr` : 'Configured in Schedules');
               return <InfoItem label="Pricing Rate" value={priceText} />;
             })()}
             <InfoItem label="Venue Type" value={formData.type || 'Outdoor'} />
             <InfoItem label="Venue Size" value={formData.venueSize} />
             <InfoItem label="Surface" value={formData.surfaceType} />
          </ReviewCard>

          {/* Operational Schedules & Pricing Breakdown */}
          <div style={{ gridColumn: '1 / -1', background: '#F8FAF7', borderRadius: '24px', padding: '2rem', border: '1.5px solid #EEF2E6' }}>
             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <Zap size={20} color="#084734" />
                  <h4 style={{ fontWeight: '800', fontSize: '1.1rem', color: '#161616', margin: 0 }}>Schedule & Slot Pricing Breakdown</h4>
                </div>
                <button onClick={() => onEdit(3)} style={{ background: 'none', border: 'none', color: '#084734', fontWeight: '800', fontSize: '0.85rem', cursor: 'pointer' }}>Edit</button>
             </div>

             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1rem' }}>
               {(formData.timings || []).map((timing, tIdx) => {
                 const isWeekend = timing.name?.includes('Weekend') || timing.name?.includes('Saturday') || timing.name?.includes('Sunday');
                 const isCustom = timing.name === 'Custom Days Range...' || (!timing.name?.includes('Weekday') && !timing.name?.includes('Weekend'));
                 const displayName = (timing.name === 'Custom Days Range...' && timing.customName) ? timing.customName : (timing.name || `Schedule #${tIdx + 1}`);
                 const schedPrice = (timing.price !== undefined && timing.price !== '' && !isNaN(parseFloat(timing.price)))
                   ? parseFloat(timing.price)
                   : (parseFloat(formData.price) || 0);
                 
                 const slots = getSlotsForTiming(timing, tIdx);
                 const activeSlots = slots.filter(s => typeof s === 'object' ? (s?.isActive !== false) : true);
                 
                 const customSlots = slots.filter(s => {
                   if (!s) return false;
                   if (typeof s === 'string') return false;
                   const sPrice = (s.price !== undefined && s.price !== null && s.price !== '') ? parseFloat(s.price) : schedPrice;
                   const hasCustomPrice = sPrice !== schedPrice;
                   const isPaused = s.isActive === false;
                   return hasCustomPrice || isPaused;
                 });

                 const cardBorder = isWeekend ? '#FCD34D' : isCustom ? '#86EFAC' : '#DCEFB8';
                 const cardBg = isWeekend ? '#FFFDF5' : isCustom ? '#F0FDF4' : '#FFFFFF';
                 const titleColor = isWeekend ? '#92400E' : isCustom ? '#166534' : '#084734';
                 const badgeBg = isWeekend ? '#FEF3C7' : isCustom ? '#DCFCE7' : '#DCEFB8';

                 return (
                   <div 
                     key={timing.id || tIdx} 
                     style={{ 
                       background: cardBg, 
                       borderRadius: '16px', 
                       border: `1.5px solid ${cardBorder}`, 
                       padding: '1.25rem',
                       display: 'flex',
                       flexDirection: 'column',
                       gap: '12px'
                     }}
                   >
                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                       <div style={{ fontWeight: '800', fontSize: '0.95rem', color: titleColor }}>
                         {isWeekend ? '🎉' : '📅'} {displayName}
                       </div>
                       <div style={{ background: badgeBg, padding: '4px 10px', borderRadius: '8px', fontWeight: '900', fontSize: '0.9rem', color: titleColor }}>
                         ₹ {schedPrice} <span style={{ fontSize: '0.75rem', fontWeight: '600' }}>/ hr</span>
                       </div>
                     </div>

                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.85rem', color: '#4B5563', fontWeight: '600' }}>
                       <span>⏰ Window: <strong style={{ color: titleColor }}>{timing.open || '06:00 AM'} - {timing.close || '10:00 PM'}</strong></span>
                       <span style={{ fontSize: '0.8rem', color: '#6B7280', fontWeight: '700' }}>{activeSlots.length} Active Slots</span>
                     </div>

                     {/* Individual Slot Range Overrides (Shown only if a slot price is customized or paused) */}
                     {customSlots.length > 0 && (
                       <div style={{ marginTop: '6px', borderTop: `1px dashed ${cardBorder}`, paddingTop: '10px' }}>
                         <div style={{ fontSize: '0.75rem', fontWeight: '800', color: '#4B5563', marginBottom: '8px' }}>
                           Customized Slot Overrides ({customSlots.length}):
                         </div>
                         <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                           {customSlots.map((sObj, sIdx) => {
                             const label = sObj?.label || sObj?.slot || '';
                             const sActive = sObj?.isActive !== false;
                             const sPrice = (sObj?.price !== undefined && sObj?.price !== '') ? parseFloat(sObj.price) : schedPrice;
                             const isDiffPrice = sPrice !== schedPrice;

                             return (
                               <div 
                                 key={sIdx}
                                 style={{
                                   background: sActive ? '#FFFFFF' : '#F1F5F9',
                                   border: `1.2px solid ${sActive ? (isWeekend ? '#FDE68A' : '#DCEFB8') : '#CBD5E1'}`,
                                   borderRadius: '8px',
                                   padding: '4px 8px',
                                   fontSize: '0.75rem',
                                   fontWeight: '750',
                                   display: 'flex',
                                   alignItems: 'center',
                                   gap: '6px',
                                   color: sActive ? '#1E293B' : '#94A3B8'
                                 }}
                               >
                                 <span>{label} {!sActive && '❄️ (Paused)'}</span>
                                 {isDiffPrice && (
                                   <span style={{ color: sActive ? '#059669' : '#94A3B8', fontWeight: '900' }}>
                                     ₹{sPrice}
                                   </span>
                                 )}
                               </div>
                             );
                           })}
                         </div>
                       </div>
                     )}
                   </div>
                 );
               })}
             </div>
          </div>

          <ReviewCard title="Amenities" step={4} onEdit={onEdit}>
             <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {formData.amenities.map(a => (
                  <span key={a} style={{ background: '#EEF2E6', padding: '6px 12px', borderRadius: '8px', fontSize: '0.75rem', fontWeight: '700', color: '#374151' }}>
                    {popular[a] || a}
                  </span>
                ))}
             </div>
          </ReviewCard>

          {/* Uploaded Photos Preview */}
          {formData.images && formData.images.length > 0 && (
            <ReviewCard title={`Uploaded Photos (${formData.images.length})`} step={5} onEdit={onEdit}>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {formData.images.map((img, idx) => {
                  const url = typeof img === 'object' && img.url ? img.url : (typeof img === 'string' ? img : '');
                  return (
                    <div key={idx} style={{ width: '80px', height: '80px', borderRadius: '12px', overflow: 'hidden', border: '1.5px solid #DCEFB8', position: 'relative' }}>
                      <img src={url} alt={`Venue photo ${idx + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                  );
                })}
              </div>
            </ReviewCard>
          )}

          <div style={{ gridColumn: '1 / -1', background: '#DCEFB8', borderRadius: '24px', padding: '2rem', border: '1.5px solid #DCEFB8', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
             <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#CEF17B', color: '#084734', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem' }}>
                <Check size={32} strokeWidth={3} />
             </div>
             <h4 style={{ fontWeight: '900', fontSize: '1.2rem', marginBottom: '8px' }}>Ready to Go Live!</h4>
             <p style={{ fontSize: '0.85rem', color: '#084734', fontWeight: '600' }}>
                Once submitted, our team will review and approve your venue within 24 hours.
             </p>
          </div>
       </div>
    </div>
  );
}

function ReviewCard({ title, children, step, onEdit }) {
  return (
    <div style={{ background: '#F8FAF7', borderRadius: '24px', padding: '2rem', border: '1.5px solid #EEF2E6' }}>
       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <h4 style={{ fontWeight: '800', fontSize: '1rem', color: '#161616' }}>{title}</h4>
          <button onClick={() => onEdit(step)} style={{ background: 'none', border: 'none', color: '#084734', fontWeight: '800', fontSize: '0.85rem', cursor: 'pointer' }}>Edit</button>
       </div>
       <div style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>{children}</div>
    </div>
  );
}

function SectionHeader({ icon, title, subtitle, small }) {
  return (
    <div style={{ marginBottom: small ? '1.5rem' : '3rem' }}>
       <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '6px' }}>
          <div style={{ color: '#084734' }}>{icon}</div>
          <h3 style={{ fontSize: small ? '1.1rem' : '1.5rem', fontWeight: '900', color: '#161616' }}>{title}</h3>
       </div>
       {subtitle && <p style={{ fontSize: '0.95rem', color: '#374151', fontWeight: '600' }}>{subtitle}</p>}
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div style={{ width: '100%' }}>
       <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '800', color: '#374151', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</label>
       {children}
    </div>
  );
}

function InfoItem({ label, value }) {
  return (
    <div>
       <div style={{ fontSize: '0.75rem', fontWeight: '700', color: '#374151', textTransform: 'uppercase', marginBottom: '4px' }}>{label}</div>
       <div style={{ fontSize: '0.95rem', fontWeight: '800', color: '#161616' }}>{value || '--'}</div>
    </div>
  );
}

const inputStyle = {
  width: '100%', padding: '16px 20px', borderRadius: '14px', border: '1.5px solid #DCEFB8',
  fontSize: '1rem', fontWeight: '600', outline: 'none', background: 'white',
  boxSizing: 'border-box', color: '#161616', transition: '0.2s border-color'
};

const whyItemStyle = { display: 'flex', alignItems: 'center', gap: '10px', fontSize: '0.85rem', color: '#374151', fontWeight: '500' };
